import HomeOutlined from '@ant-design/icons/HomeOutlined'
import allPaths from '../Config/paths'

const bgColor = '#0adc00'

const drawerRoutes = [
    {
        title: 'Home',
        route: allPaths.HOME,
        icon: <HomeOutlined />
    }
]

let List = [
    //Lista 1
    [{
        domanda: 'Abitanti dell’Italia',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Parassiti che vivono tra i capelli',
        risposta: 'ITALIANI',
    }, {
        domanda: 'Animali che sono il titolo di un film di Hitchcock',
        risposta: 'PIDOCCHI',
    }, {
        domanda: 'Secondo Marilyn Monroe sono i migliori amici delle ragazze',
        risposta: 'UCCELLI',
    }, {
        domanda: 'Dolorose possono essere addominali biliari o renali',
        risposta: 'DIAMANTI',
    }, {
        domanda: 'Quelle d’amore le soffrono gli innamorati',
        risposta: 'COLICHE',
    }, {
        domanda: 'Premier predecessore di Monti',
        risposta: 'PENE',
    }, {
        domanda: 'Divo porno italiano',
        risposta: 'BERLUSCONI',
    }, {
        domanda: 'Sotto i materassi di una principessa nella favola',
        risposta: 'SIFFREDI',
    }, {
        domanda: 'Tubero che si mangia al cartoccio',
        risposta: 'PISELLO',
    }, {
        domanda: 'L’ha mostrata Belen scendendo dalle scale a Sanremo',
        risposta: 'PATATA',
    }, {
        domanda: 'Spremuta diventa una bevanda ricca di vitamina C',
        risposta: 'FARFALLA',
    }, {
        domanda: 'Con una si possono catturare due piccioni',
        risposta: 'ARANCIA',
    }, {
        domanda: 'La si stringe all’altra persona presentandosi',
        risposta: 'FAVA',
    }, {
        domanda: 'Contiene e protegge i genitali maschili nella pratica sportiva',
        risposta: 'MANO',
    }],
    //Lista 2
    [{
        domanda: 'Trainavano l\'aratro',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Animali a cui è ispirato Bugs Bunny',
        risposta: 'BUOI',
    }, {
        domanda: 'Tipico dolce natalizio',
        risposta: 'CONIGLIO',
    }, {
        domanda: 'È armato in alcuni edifici',
        risposta: 'PANETTONE',
    }, {
        domanda: 'La parte del viso sotto la bocca',
        risposta: 'CEMENTO',
    }, {
        domanda: 'Il classico gusto del dentifricio',
        risposta: 'MENTO',
    }, {
        domanda: 'Ci appicchi le figurine',
        risposta: 'MENTA',
    }, {
        domanda: 'Il rosso dell\'uovo',
        risposta: 'ALBUM',
    }, {
        domanda: 'Se non hai ragione hai..?',
        risposta: 'TUORLO',
    }, {
        domanda: 'Che cos\'è la Sacher?',
        risposta: 'TORTO',
    }, {
        domanda: 'Piatto tipico partenopeo',
        risposta: 'TORTA',
    }, {
        domanda: 'Parti del corpo all\'estremità dei seni',
        risposta: 'PIZZA',
    }, {
        domanda: 'Se li hai stanchi te li stropicci',
        risposta: 'CAPEZZOLI',
    }, {
        domanda: 'Molti bambini li sistemano con l\'apparecchio',
        risposta: 'OCCHI',
    }, {
        domanda: '4x5?',
        risposta: 'DENTI',
    }],
    //Lista 3
    [{
        domanda: 'Si radono sotto le ascelle',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'La margherita: pomodoro e..',
        risposta: 'PELI',
    }, {
        domanda: 'Presidente della Repubblica di nome Sergio',
        risposta: 'MOZZARELLA',
    }, {
        domanda: 'Strumento utilizzato per stendere la pasta',
        risposta: 'MATTARELLA',
    }, {
        domanda: 'Chi va con lui impara a zoppicare',
        risposta: 'MATTARELLO',
    }, {
        domanda: 'Se non è pan bagnato è...',
        risposta: 'ZOPPO',
    }, {
        domanda: 'Per rendere i capelli morbidi, usato durante il lavaggio',
        risposta: 'ZUPPA',
    }, {
        domanda: 'Si soffrigge per i sughi',
        risposta: 'BALSAMO',
    }, {
        domanda: 'La metti sul telefono perchè non si rovini',
        risposta: 'CIPOLLA',
    }, {
        domanda: 'Nome completo dell\'automobile Mini',
        risposta: 'COVER',
    }, {
        domanda: 'Cognome del cantante Vasco',
        risposta: 'COOPER',
    }, {
        domanda: 'Così vengono chiamati i tifosi più accaniti',
        risposta: 'ROSSI',
    }, {
        domanda: 'I soldati romani',
        risposta: 'ULTRAS',
    }, {
        domanda: 'Compiono atti di vandalismo',
        risposta: 'LEGIONARI',
    }, {
        domanda: 'Lo sono i vecchi che sanno tante cose',
        risposta: 'VANDALI',
    }],
    //Lista 4
    [{
        domanda: 'Bevanda al malto',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'La fai subito se bevi tanta acqua',
        risposta: 'BIRRA',
    }, {
        domanda: 'Si mette sui denti da bambini per sistemarli',
        risposta: 'PIPÌ',
    }, {
        domanda: 'Bicicletta con una sola ruota',
        risposta: 'APPARECCHIO',
    }, {
        domanda: 'Occhiale con una sola lente',
        risposta: 'MONOCICLO',
    }, {
        domanda: 'L\'essere mitologico con un solo occhio',
        risposta: 'MONOCOLO',
    }, {
        domanda: 'Ogni mese lo hanno le ragazze',
        risposta: 'CICLOPE',
    }, {
        domanda: 'Lo bevono in Inghilterra al pomeriggio',
        risposta: 'CICLO',
    }, {
        domanda: 'Lo si spinge mentre si fa la spesa',
        risposta: 'TE',
    }, {
        domanda: 'Grande nave in cui si trascorrono vacanze',
        risposta: 'CARRELLO',
    }, {
        domanda: 'Ci è morto Gesù',
        risposta: 'CROCIERA',
    }, {
        domanda: 'Il simbolo della Ferrari',
        risposta: 'CROCE',
    }, {
        domanda: 'Ha una perversione sessuale per i bambini',
        risposta: 'CAVALLINO',
    }, {
        domanda: 'Serve i clienti al ristorante',
        risposta: 'PEDOFILO',
    }, {
        domanda: 'Sistema le tubature',
        risposta: 'CAMERIERE',
    }],
    //Lista 5
    [{
        domanda: 'Li indossi se non ci vedi bene',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Possono essere a sventola',
        risposta: 'OCCHIALI',
    }, {
        domanda: 'Posate asiatiche',
        risposta: 'ORECCHIE',
    }, {
        domanda: 'Si usano per pagare senza contanti',
        risposta: 'BACCHETTE',
    }, {
        domanda: 'Usate in guerra, esplodono',
        risposta: 'CARTE DI CREDITO',
    }, {
        domanda: 'Fatte con il ghiaccio, siciliane ed estive',
        risposta: 'GRANATE',
    }, {
        domanda: 'Di Carrara, usato per sculture e mobilia',
        risposta: 'GRANITE',
    }, {
        domanda: 'Si dice di persona che parla molto',
        risposta: 'MARMO',
    }, {
        domanda: 'Feci molli',
        risposta: 'LOGORROICA',
    }, {
        domanda: 'La si spalma per rendere le mani morbide',
        risposta: 'DIARREA',
    }, {
        domanda: 'Città capoluogo della Lombardia',
        risposta: 'CREMA',
    }, {
        domanda: 'Ci si va quando si ha male ai denti',
        risposta: 'MILANO',
    }, {
        domanda: 'Si occupa di tagliare legna nei boschi',
        risposta: 'DENTISTA',
    }, {
        domanda: 'Papà di Pinocchio',
        risposta: 'BOSCAIOLO',
    }, {
        domanda: 'Nome di Trump, presidente americano',
        risposta: 'GEPPETTO',
    }],
    //Lista 6
    [{
        domanda: 'Oggetto con le pagine da leggere',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Ti ci pulisci il sedere',
        risposta: 'LIBRO',
    }, {
        domanda: 'L\'uomo ne è fatto per il 70%',
        risposta: 'CARTA IGIENICA',
    }, {
        domanda: 'Se ne bevi troppo ti ubriachi',
        risposta: 'ACQUA',
    }, {
        domanda: 'Il terzo comico dopo Giovanni e Giacomo',
        risposta: 'ALCOL',
    }, {
        domanda: 'Lo è chi non possiede la vista',
        risposta: 'ALDO',
    }, {
        domanda: 'Abitante delle Norvegia',
        risposta: 'CIECO',
    }, {
        domanda: 'La pizza è un piatto tipico della cucina..',
        risposta: 'NORVEGESE',
    }, {
        domanda: 'La donna che legge le carte',
        risposta: 'NAPOLETANA',
    }, {
        domanda: 'Il gioco da tavolo dove si acquistano proprietà',
        risposta: 'CARTOMANTE',
    }, {
        domanda: 'Lo ha lo stato con il tabacco',
        risposta: 'MONOPOLI',
    }, {
        domanda: 'Lo hai quando vuoi dormire',
        risposta: 'MONOPOLIO',
    }, {
        domanda: 'Egli è, tu sei, io..',
        risposta: 'SONNO',
    }, {
        domanda: 'Quale velocità ha superato un aereo supersonico?',
        risposta: 'SONO',
    }, {
        domanda: 'Altro modo di dire maiale, con la S',
        risposta: 'SUONO',
    }],
    //Lista 7
    [{
        domanda: 'In Italia si chiama pallacanestro, in America?',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'In America si chiama basket, in Italia?',
        risposta: 'BASKET',
    }, {
        domanda: 'In Italia si chiama tennis, in America?',
        risposta: 'PALLACANESTRO',
    }, {
        domanda: 'Valentino Rossi è un campione di quale sport?',
        risposta: 'TENNIS',
    }, {
        domanda: 'L\'America\'s Cup è un trofeo di quale sport?',
        risposta: 'MOTOCICLISMO',
    }, {
        domanda: 'Vogue Donna è una rivista di..?',
        risposta: 'VELA',
    }, {
        domanda: 'Il gruppo italiano che ha come leader Kekko',
        risposta: 'MODA',
    }, {
        domanda: 'Il gruppo italiano che canta Shpalman',
        risposta: 'MODÀ',
    }, {
        domanda: 'Corrono negli ippodromi',
        risposta: 'ELIO E LE STORIE TESE',
    }, {
        domanda: 'Corrono nei cinodromi',
        risposta: 'CAVALLI',
    }, {
        domanda: 'Corrono nei velodromi',
        risposta: 'CANI',
    }, {
        domanda: 'Corrono dei cartodromi',
        risposta: 'CICLISTI',
    }, {
        domanda: 'Cosa erano la Nina, la Pinta e la Santa Maria?',
        risposta: 'KART',
    }, {
        domanda: 'Cosa sono le Fisherman?',
        risposta: 'CARAVELLE',
    }, {
        domanda: 'Le si prende in discoteca per sballarsi',
        risposta: 'CARAMELLE',
    }],
    //Lista 8
    [{
        domanda: 'Gamberi grandi',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Dolci inzuppati nel vino',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Legano le scarpe',
        risposta: 'CANTUCCI',
    }, {
        domanda: 'Città del Salento con la L',
        risposta: 'LACCI',
    }, {
        domanda: 'Ci vanno a pregare i musulmani',
        risposta: 'LECCE',
    }, {
        domanda: 'Ronza attorno alla merda',
        risposta: 'MOSCHEA',
    }, {
        domanda: 'Capitale della Russia',
        risposta: 'MOSCA',
    }, {
        domanda: 'In Pinocchio: il gatto e la..',
        risposta: 'MOSCA',
    }, {
        domanda: 'Si usa per fare il caffè',
        risposta: 'VOLPE',
    }, {
        domanda: 'La cola più famosa',
        risposta: 'MOKA',
    }, {
        domanda: 'La droga tipicamente iniettata in vena',
        risposta: 'COCA',
    }, {
        domanda: 'Braccio di ferro ne fa uso per aumentare la sua forza',
        risposta: 'EROINA',
    }, {
        domanda: 'Si mettono alle orecchie per vezzo',
        risposta: 'SPINACI',
    }, {
        domanda: 'Si infiltrano nei sistemi informatici',
        risposta: 'ORECCHINI',
    }, {
        domanda: 'Sinonimo francese di WC',
        risposta: 'HACKER',
    }],
    //Lista 9
    [{
        domanda: 'La cantante di "Like a virgin"',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Divinità egizia con testa di cane',
        risposta: 'MADONNA',
    }, {
        domanda: 'Sono in cielo e ne scende la pioggia',
        risposta: 'ANUBI',
    }, {
        domanda: 'Fritte come accompagnamento all\'hamburger',
        risposta: 'NUVOLE',
    }, {
        domanda: 'Nei capelli delle donne per formare i ricci',
        risposta: 'PATATINE',
    }, {
        domanda: 'Si estinsero con un meteorite',
        risposta: 'BIGODINI',
    }, {
        domanda: 'Animali ciechi che scavano tunnel e buche',
        risposta: 'DINOSAURI',
    }, {
        domanda: 'Colpo di stato',
        risposta: 'TALPE',
    }, {
        domanda: 'Sport di Tiger Woods',
        risposta: 'GOLPE',
    }, {
        domanda: 'Indossata dai manager sotto la giacca',
        risposta: 'GOLF',
    }, {
        domanda: 'Ingrediente base della parmigiana',
        risposta: 'CAMICIA',
    }, {
        domanda: 'Persona vecchia',
        risposta: 'MELANZANA',
    }, {
        domanda: 'Lo è Giusy Ferreri',
        risposta: 'ANZIANA',
    }, {
        domanda: 'Animale domestico che abbaia',
        risposta: 'CANTANTE',
    }, {
        domanda: 'Tipo di bistecca tradizionale di Milano',
        risposta: 'CANE',
    }],
    //Lista 10
    [{
        domanda: 'Si mettono sulla torta di compleanno',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Le ballerine di Striscia la notizia',
        risposta: 'CANDELINE',
    }, {
        domanda: 'Si mettono direttamente sugli occhi al posto degli occhiali',
        risposta: 'VELINE',
    }, {
        domanda: 'Corridori dei cento metri',
        risposta: 'LENTI',
    }, {
        domanda: 'Domano gli incendi',
        risposta: 'CENTOMETRISTI',
    }, {
        domanda: 'Appiccano incendi volontariamente',
        risposta: 'VIGILI DEL FUOCO',
    }, {
        domanda: 'Persona che mente',
        risposta: 'PIROMANI',
    }, {
        domanda: 'Lo è Pinocchio',
        risposta: 'BUGIARDO',
    }, {
        domanda: 'La burrata è un tipo di..?',
        risposta: 'BURATTINO',
    }, {
        domanda: 'Si mette sulla ruota quando c\'è neve',
        risposta: 'FORMAGGIO',
    }, {
        domanda: 'Il berretto del papa',
        risposta: 'CATENA',
    }, {
        domanda: 'L\'auto del papa',
        risposta: 'PAPALINA',
    }, {
        domanda: 'L\'auto di Batman',
        risposta: 'PAPAMOBILE',
    }, {
        domanda: 'L\'auto tedesca Benz',
        risposta: 'BATMOBILE',
    }, {
        domanda: 'Nome del politico cubano Castro',
        risposta: 'MERCEDES',
    }],
    //Lista 11
    [{
        domanda: 'Si usa per coprire il cuscino',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Cognome di Roger tennista',
        risposta: 'FEDERA',
    }, {
        domanda: 'La famosa marca di crema al cioccolato',
        risposta: 'FEDERER',
    }, {
        domanda: 'A Roma si fa alla Giudia',
        risposta: 'NUTELLA',
    }, {
        domanda: 'Formato di medicinale da inserire nell\'ano',
        risposta: 'CARCIOFO',
    }, {
        domanda: 'Arma contundente usata da Fred Flinstones',
        risposta: 'SUPPOSTA',
    }, {
        domanda: 'Si lancia dietro la schiena per portare fortuna',
        risposta: 'CLAVA',
    }, {
        domanda: 'Si può utilizzare a zollette',
        risposta: 'SALE',
    }, {
        domanda: 'Si inietta per sconfiggere preventivamente le malattie',
        risposta: 'ZUCCHERO',
    }, {
        domanda: 'Utilizzato per far crescere le piante',
        risposta: 'VACCINO',
    }, {
        domanda: 'Gli orsi ne sono ghiotti',
        risposta: 'FERTILIZZANTE',
    }, {
        domanda: 'Esce durante l\'eiaculazione',
        risposta: 'MIELE',
    }, {
        domanda: 'Celebre salsa da accompagnare alle patatine',
        risposta: 'SBORRA',
    }, {
        domanda: 'Si dice quando qualcuno starnutisce',
        risposta: 'KETCHUP',
    }, {
        domanda: 'Napoleone la teneva coperta sotto la giacca',
        risposta: 'SALUTE',
    }],
    //Lista 12
    [{
        domanda: 'Corre sulle rotaie',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Capoluogo del Trentino',
        risposta: 'TRENO',
    }, {
        domanda: '5x6',
        risposta: 'TRENTO',
    }, {
        domanda: '99+3',
        risposta: 'TRENTA',
    }, {
        domanda: 'Quanti erano i cani della "Carica" Disney',
        risposta: '102',
    }, {
        domanda: 'Diego, celebre calciatore argentino',
        risposta: '101',
    }, {
        domanda: 'Si corre quella di New York',
        risposta: 'MARADONA',
    }, {
        domanda: 'Opera filmica in episodi',
        risposta: 'MARATONA',
    }, {
        domanda: 'Il campionato di calcio maggiore italiano',
        risposta: 'SERIE',
    }, {
        domanda: 'Il luogo in cui si giudicano i crimini',
        risposta: 'SERIE A',
    }, {
        domanda: 'Quella d\'onore per assistere ad uno spettacolo',
        risposta: 'TRIBUNALE',
    }, {
        domanda: 'Quella di cavallo con i capelli',
        risposta: 'TRIBUNA',
    }, {
        domanda: 'Ci vive la lumaca',
        risposta: 'CODA',
    }, {
        domanda: 'Quello di zucca si fa fritto',
        risposta: 'GUSCIO',
    }, {
        domanda: 'Puzza se mangi aglio',
        risposta: 'FIORE',
    }],
    //Lista 13
    [{
        domanda: 'Lo mettono le donne sulle labbra',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Matita usata dai bambini per colorare',
        risposta: 'ROSSETTO',
    }, {
        domanda: 'I rigatoni sono un tipo di..?',
        risposta: 'PASTELLO',
    }, {
        domanda: 'Lo è la Ketamina',
        risposta: 'PASTA',
    }, {
        domanda: 'Si mangiano guardando i film al cinema',
        risposta: 'DROGA',
    }, {
        domanda: 'Salsiccia tipica tedesca',
        risposta: 'POPCORN',
    }, {
        domanda: 'Lo hanno i maschi in mezzo alle gambe',
        risposta: 'WURSTEL',
    }, {
        domanda: 'Si inzuppa nel latte o nel te al mattino',
        risposta: 'PENE',
    }, {
        domanda: 'Il tipico cibo mangiato dai conigli',
        risposta: 'BISCOTTO',
    }, {
        domanda: 'Inserito nel culo dal proctologo',
        risposta: 'CAROTE',
    }, {
        domanda: 'Si fa chiudendo un solo occhio',
        risposta: 'DITO',
    }, {
        domanda: 'Chiude una trattativa',
        risposta: 'OCCHIOLINO',
    }, {
        domanda: 'Usato dall\'arbitro per interrompere il gioco',
        risposta: 'STRETTA DI MANO',
    }, {
        domanda: 'Tra l\'Europa e l\'America',
        risposta: 'FISCHIETTO',
    }, {
        domanda: 'Una persona estremamente grassa',
        risposta: 'OCEANO',
    }],
    //Lista 14
    [{
        domanda: 'Li usano le automobili per illuminare la strada',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Sono preziosi e li trovano i cani nei boschi',
        risposta: 'FANALI',
    }, {
        domanda: 'Ce le si toglie dal naso di nascosto',
        risposta: 'TARTUFI',
    }, {
        domanda: 'Le si da ai mendicanti',
        risposta: 'CACCOLE',
    }, {
        domanda: 'Usate dai batteristi per suonare',
        risposta: 'MONETE',
    }, {
        domanda: 'Le cavalca per volare Harry Potter',
        risposta: 'BACCHETTE',
    }, {
        domanda: 'Armi contundenti della polizia',
        risposta: 'SCOPE',
    }, {
        domanda: 'In mazzo si regalano alle ragazze',
        risposta: 'MANGANELLI',
    }, {
        domanda: 'Scariche elettriche dal cielo',
        risposta: 'FIORI',
    }, {
        domanda: 'Li lancia il giavellottista',
        risposta: 'FULMINI',
    }, {
        domanda: 'Nome d\'arte di Lorenzo Cherubini',
        risposta: 'GIAVELLOTTI',
    }, {
        domanda: 'Il contrario di vecchi',
        risposta: 'JOVANOTTI',
    }, {
        domanda: 'Rubano',
        risposta: 'GIOVANI',
    }, {
        domanda: 'Di lavoro producono torte e pasticcini',
        risposta: 'LADRI',
    }, {
        domanda: 'Persone pelate',
        risposta: 'PASTICCERI',
    }],
    //Lista 15
    [{
        domanda: 'Rimangono sulla neve dopo che ci cammini',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Le hanno i granchi',
        risposta: 'IMPRONTE',
    }, {
        domanda: 'Il nome dell\'Arcangelo dell\'Annunciazione',
        risposta: 'CHELE',
    }, {
        domanda: 'Lo è chi non vuole dare soldi',
        risposta: 'GABRIELE',
    }, {
        domanda: 'Il famoso Alberto, sciista italiano',
        risposta: 'TACCAGNO',
    }, {
        domanda: 'Se la fa chi vuole abbronzarsi',
        risposta: 'TOMBA',
    }, {
        domanda: 'Nella favola è nella roccia',
        risposta: 'LAMPADA',
    }, {
        domanda: 'Te la fai quando sei sporco',
        risposta: 'SPADA',
    }, {
        domanda: 'Fa traboccare il vaso',
        risposta: 'DOCCIA',
    }, {
        domanda: 'La città dei sassi',
        risposta: 'GOCCIA',
    }, {
        domanda: 'La città dei Beatles',
        risposta: 'MATERA',
    }, {
        domanda: 'Ci si va per fare sistemare le scarpe',
        risposta: 'LIVERPOOL',
    }, {
        domanda: 'Frutto esotico verde e burroso',
        risposta: 'CALZOLAIO',
    }, {
        domanda: 'Lo si chiama per difendersi ad un processo',
        risposta: 'AVOCADO',
    }, {
        domanda: 'Lo è Mike Tyson',
        risposta: 'AVVOCATO',
    }],
    //Lista 16
    [{
        domanda: 'Li ha il calciatore ai piedi',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'La fai con il pane nel sugo',
        risposta: 'SCARPINI',
    }, {
        domanda: 'Mangia la nonna di Cappuccetto Rosso',
        risposta: 'SCARPETTA',
    }, {
        domanda: 'Canta "Gelato al cioccolato"',
        risposta: 'LUPO',
    }, {
        domanda: 'Acquisisce dei superpoteri dopo il morso di un ragno',
        risposta: 'PUPO',
    }, {
        domanda: 'Raccoglie la spazzatura',
        risposta: 'SPIDER MAN',
    }, {
        domanda: 'Il pesce che si gonfia a sfera',
        risposta: 'SPAZZINO',
    }, {
        domanda: 'Lo mangiano gli americani al Thanksgiving Day',
        risposta: 'PESCE PALLA',
    }, {
        domanda: 'Ci veniva rinchiuso un matto',
        risposta: 'TACCHINO',
    }, {
        domanda: 'Luogo di villeggiatura con gli animatori',
        risposta: 'MANICOMIO',
    }, {
        domanda: 'Palazzo con diverse abitazioni',
        risposta: 'VILLAGGIO VACANZE',
    }, {
        domanda: 'Alcolico fatto con l\'uva',
        risposta: 'CONDOMINIO',
    }, {
        domanda: 'Le sue foglie sono dette "aghi"',
        risposta: 'VINO',
    }, {
        domanda: 'nome dell\'ex presidente Obama',
        risposta: 'PINO',
    }, {
        domanda: 'casa su ruote trainabile dalla macchina',
        risposta: 'BARACK',
    }],
    //Lista 17
    [{
        domanda: 'Riflettono l\'immagine',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Proteggono dal sole in spiaggia',
        risposta: 'SPECCHI',
    }, {
        domanda: 'Crescono sugli ulivi',
        risposta: 'OMBRELLONI',
    }, {
        domanda: 'Vivono attaccate agli scogli',
        risposta: 'OLIVE',
    }, {
        domanda: 'Hanno tre lati',
        risposta: 'COZZE',
    }, {
        domanda: 'Il match calcistico tra due squadre della stessa città',
        risposta: 'TRIANGOLI',
    }, {
        domanda: 'Gli animali da seta',
        risposta: 'DERBY',
    }, {
        domanda: 'Li ha il tossico nel braccio',
        risposta: 'BACHI',
    }, {
        domanda: 'In vacanza, si spedivano ad amici e familiari',
        risposta: 'BUCHI',
    }, {
        domanda: 'Le sedie ne hanno 4',
        risposta: 'CARTOLINE',
    }, {
        domanda: 'Dormono a testa in giù',
        risposta: 'GAMBE',
    }, {
        domanda: 'Abbreviazione di Disk Jockey',
        risposta: 'PIPISTRELLI',
    }, {
        domanda: 'Mezzo di trasporto subacqueo',
        risposta: 'DJ',
    }, {
        domanda: 'Locale della casa in cui si ripongono oggetti poco utilizzati',
        risposta: 'SOTTOMARINO',
    }, {
        domanda: 'Monte più alto del mondo',
        risposta: 'SGABUZZINO',
    }],
    //Lista 18
    [{
        domanda: 'Sono dei paesi tuoi con i buoi',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Chiedono elemosina e sono donne nomadi',
        risposta: 'MOGLI',
    }, {
        domanda: 'Contengono liquidi',
        risposta: 'ZINGARE',
    }, {
        domanda: 'Lo strumento di Jimi Hendrix',
        risposta: 'BOTTIGLIE',
    }, {
        domanda: 'Piatto di carne cruda tagliata',
        risposta: 'CHITARRA',
    }, {
        domanda: 'Giallo o marrone, si accumula sui denti',
        risposta: 'TARTARE',
    }, {
        domanda: 'Il materiale del Cavallo di Troia',
        risposta: 'TARTARO',
    }, {
        domanda: 'È detto Romano quello fascista',
        risposta: 'LEGNO',
    }, {
        domanda: 'Si applica sul viso per la bellezza della pelle',
        risposta: 'SALUTO',
    }, {
        domanda: 'Sostiene la macchina fotografica',
        risposta: 'MASCHERA',
    }, {
        domanda: 'Usate per camminare sulla neve',
        risposta: 'TREPPIEDE',
    }, {
        domanda: 'Composizioni giapponesi con la carta',
        risposta: 'RACCHETTE',
    }, {
        domanda: 'Hanno più mogli',
        risposta: 'ORIGAMI',
    }, {
        domanda: 'Vivono nei formicai',
        risposta: 'POLIGAMI',
    }, {
        domanda: 'Le guida il pastore',
        risposta: 'FORMICHE',
    }],
    //Lista 19
    [{
        domanda: 'Legumi che portano fortuna',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Maschio oppure..?',
        risposta: 'LENTICCHIE',
    }, {
        domanda: 'D\'estate è fastidiosa e punge',
        risposta: 'FEMMINA',
    }, {
        domanda: 'È di molti colori nel karate',
        risposta: 'ZANZARA',
    }, {
        domanda: 'Le amazzoni ne hanno solo una',
        risposta: 'CINTURA',
    }, {
        domanda: 'Se la annusi può sapere di sudore',
        risposta: 'TETTA',
    }, {
        domanda: 'Insetto a puntini che porta fortuna',
        risposta: 'ASCELLA',
    }, {
        domanda: 'Di cartone, usata per spedire oggetti',
        risposta: 'COCCINELLA',
    }, {
        domanda: 'Ci dormono i neonati',
        risposta: 'SCATOLA',
    }, {
        domanda: 'Ci si nuota per allenarsi',
        risposta: 'CULLA',
    }, {
        domanda: 'Il cesso dove si sta accovacciati',
        risposta: 'PISCINA',
    }, {
        domanda: 'Donna tutta tana',
        risposta: 'TURCA',
    }, {
        domanda: 'Si usa per legarsi i capelli',
        risposta: 'NANA',
    }, {
        domanda: 'La Beretta che spara',
        risposta: 'ELASTICO',
    }, {
        domanda: 'Lo diventa un uomo che ha bevuto troppo',
        risposta: 'PISTOLA',
    }],
    //Lista 20
    [{
        domanda: 'Il pattern della maglia della Juventus',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Sotto la panca crepa',
        risposta: 'RIGHE',
    }, {
        domanda: 'Sta sotto la capra',
        risposta: 'CAPRA',
    }, {
        domanda: 'Gioco a forma conica, che gira vorticosamente',
        risposta: 'PANCA',
    }, {
        domanda: 'Colpo violento dall\'alto al basso nel tennis',
        risposta: 'TROTTOLA',
    }, {
        domanda: 'La disciplina del bodybuilder, in italiano',
        risposta: 'SMASH',
    }, {
        domanda: 'In Liguria si mangia con le trofie',
        risposta: 'CULTURISMO',
    }, {
        domanda: 'Ci vivono i topi sotto le città',
        risposta: 'PESTO',
    }, {
        domanda: 'Si usa per arrivare ai piani alti di un edificio',
        risposta: 'FOGNA',
    }, {
        domanda: 'La massima carica nell\'Università',
        risposta: 'ASCENSORE',
    }, {
        domanda: 'Vi si innescano le reazioni nucleari',
        risposta: 'RETTORE',
    }, {
        domanda: 'La Donatella della canzone italiana',
        risposta: 'REATTORE',
    }, {
        domanda: 'Levatoio, separa la fortezza dall\'esterno',
        risposta: 'RETTORE',
    }, {
        domanda: 'Tra il dire e il fare',
        risposta: 'PONTE',
    }, {
        domanda: 'Vi si mettono i defunti',
        risposta: 'MARE',
    }],
    //Lista 21
    [{
        domanda: 'Lo sono le Camel',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Ingrediente del risotto giallo alla Milanese',
        risposta: 'SIGARETTE',
    }, {
        domanda: 'Disegno permanente sul corpo',
        risposta: 'ZAFFERANO',
    }, {
        domanda: 'Le auto ci girano in circolo e poi escono',
        risposta: 'TATUAGGIO',
    }, {
        domanda: 'Ne esce la birra al pub',
        risposta: 'ROTONDA',
    }, {
        domanda: 'È la bocca degli uccelli',
        risposta: 'SPINA',
    }, {
        domanda: 'Detto anche minchia, fallo, pisello',
        risposta: 'BECCO',
    }, {
        domanda: 'Lo si patisce d\'estate',
        risposta: 'PENE',
    }, {
        domanda: 'Gusto tipico del Moscow Mule',
        risposta: 'CALDO',
    }, {
        domanda: 'Si fa quando si investe sulla possibilità di un risultato',
        risposta: 'ZENZERO',
    }, {
        domanda: 'Ci vanno i credenti la domenica mattina',
        risposta: 'SCOMMESSA',
    }, {
        domanda: 'Leo, calciatore argentino del Barcellona',
        risposta: 'MESSA',
    }, {
        domanda: 'Blocchetto d\'oro',
        risposta: 'MESSI',
    }, {
        domanda: 'Cresce nella pancia di una mamma',
        risposta: 'LINGOTTO',
    }, {
        domanda: 'Lo è Albano',
        risposta: 'BAMBINO',
    }],
    //Lista 22
    [{
        domanda: 'Si fanno quelli del sangue',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Scagliette bianche alla base del capello',
        risposta: 'PRELIEVI',
    }, {
        domanda: 'Grattugiato sulla pasta',
        risposta: 'FORFORA',
    }, {
        domanda: 'Un abitante di Marte',
        risposta: 'PARMIGIANO',
    }, {
        domanda: 'Nome di Bisio',
        risposta: 'MARZIANO',
    }, {
        domanda: 'Dove ha la testa qualcuno che è distratto?',
        risposta: 'CLAUDIO',
    }, {
        domanda: 'Alcuni animali le fanno a pallini',
        risposta: 'NUVOLE',
    }, {
        domanda: 'Posate a terra per coprire i pavimenti',
        risposta: 'FECI',
    }, {
        domanda: 'Si prende a pugni per allenarsi',
        risposta: 'PIASTRELLE',
    }, {
        domanda: 'È matto negli scacchi',
        risposta: 'SACCO',
    }, {
        domanda: 'Il santo che dà il nome allo stadio di Milano',
        risposta: 'SCACCO',
    }, {
        domanda: 'La nostra stella',
        risposta: 'SIRO',
    }, {
        domanda: 'Nel gioco insieme a carta e forbice',
        risposta: 'SOLE',
    }, {
        domanda: 'Si lancia contro la nave al varo',
        risposta: 'SASSO',
    }, {
        domanda: 'Grande strumento da guerra per lanci di oggetti pesanti',
        risposta: 'BOTTIGLIA',
    }],
    //Lista 23
    [{
        domanda: 'Periodo di riposo dal lavoro',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Vi recitano gli attori a teatro',
        risposta: 'VACANZE',
    }, {
        domanda: 'Impronta in gesso del negativo di un oggetto',
        risposta: 'PALCO',
    }, {
        domanda: 'Applicato su piccole ferite',
        risposta: 'GESSO',
    }, {
        domanda: 'Applicato per guarire ossa rotte',
        risposta: 'CEROTTO',
    }, {
        domanda: 'Sex in italiano',
        risposta: 'GESSO',
    }, {
        domanda: 'Lo fanno alcuni animali nelle stagioni invernali',
        risposta: 'SESSO',
    }, {
        domanda: 'Meeting di lavoro',
        risposta: 'LETARGO',
    }, {
        domanda: 'Allineamento di Luna e Sole con conseguente oscuramento',
        risposta: 'RIUNIONE',
    }, {
        domanda: 'Ne soffrono la maggior parte degli uomini ai capelli',
        risposta: 'ECLISSI',
    }, {
        domanda: 'Corsa di automobili su strade sterrate',
        risposta: 'CALVIZIE',
    }, {
        domanda: 'Sport in cui si effettua il bagher',
        risposta: 'RALLY',
    }, {
        domanda: 'Competizione a cavallo tra contrade',
        risposta: 'PALLAVOLO',
    }, {
        domanda: 'Gioco napoletano casalingo con pescaggio di numeri',
        risposta: 'PALIO',
    }, {
        domanda: 'Espressione facciale di gioia',
        risposta: 'TOMBOLA',
    }],
    //Lista 24
    [{
        domanda: 'Ci si fanno i calcoli',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Lo è Merlino',
        risposta: 'CALCOLATRICE',
    }, {
        domanda: 'Strumento elettrico a quattro corde',
        risposta: 'MAGO',
    }, {
        domanda: 'Lo è generalmente un giocatore di basket',
        risposta: 'BASSO',
    }, {
        domanda: 'Comunica la scienza al pubblico',
        risposta: 'ALTO',
    }, {
        domanda: 'Persona con perversioni',
        risposta: 'DIVULGATORE',
    }, {
        domanda: 'Il lavoro di Carlo Conti',
        risposta: 'PERVERTITO',
    }, {
        domanda: 'Ha sei facce',
        risposta: 'PRESENTATORE',
    }, {
        domanda: 'Bevanda alla frutta in brick',
        risposta: 'CUBO',
    }, {
        domanda: 'Se tu succhi, io..?',
        risposta: 'SUCCO',
    }, {
        domanda: 'Contrazione improvvisa e involontaria di un muscolo',
        risposta: 'SUCCHIO',
    }, {
        domanda: 'Fase di godimento massimo nell\'atto sessuale',
        risposta: 'SPASMO',
    }, {
        domanda: 'Usato nella lavatrice',
        risposta: 'ORGASMO',
    }, {
        domanda: 'Forma di scrittura con le grazie',
        risposta: 'DETERSIVO',
    }, {
        domanda: 'Tipo di volume che caratterizza le antiche strutture egizie',
        risposta: 'CORSIVO',
    }],
    //Lista 25
    [{
        domanda: 'Si indossano tra i piedi e le scarpe',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Contraccettivo per uomini',
        risposta: 'CALZINI',
    }, {
        domanda: 'Per i bambini: si gonfia e si lega ad una cordicella',
        risposta: 'PRESERVATIVO',
    }, {
        domanda: 'Si usa per battere i chiodi',
        risposta: 'PALLONCINO',
    }, {
        domanda: 'Membro riproduttivo maschile',
        risposta: 'MARTELLO',
    }, {
        domanda: 'Si mangia a colazione con il cappuccino',
        risposta: 'CAZZO',
    }, {
        domanda: 'Il metallo prezioso con cui si fabbricano i gioielli',
        risposta: 'CROISSANT',
    }, {
        domanda: 'Lo si raccoglie nelle piantagioni di cotone',
        risposta: 'ORO',
    }, {
        domanda: 'La carbonara: guanciale, pecorino e...',
        risposta: 'COTONE',
    }, {
        domanda: 'Si fa sul water quando si ha mal di pancia',
        risposta: 'UOVO',
    }, {
        domanda: 'Veniva chiamato cosi Benito Mussolini',
        risposta: 'CACCA',
    }, {
        domanda: 'Si indossa in testa con il frontino',
        risposta: 'DUCE',
    }, {
        domanda: 'Ci metti il cibo da portare a lavoro',
        risposta: 'CAPPELLO',
    }, {
        domanda: 'La punta del pene',
        risposta: 'SCHISCETTA',
    }, {
        domanda: 'Gelato: cono o..?',
        risposta: 'CAPPELLA',
    }],
    //Lista 26
    [{
        domanda: 'Tanto va la gatta al...',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'La tipica torta pere e...',
        risposta: 'LARDO',
    }, {
        domanda: 'Ci si fanno i risciacqui per pulire la bocca',
        risposta: 'CIOCCOLATO',
    }, {
        domanda: 'Preferisce acqua naturale o...?',
        risposta: 'COLLUTTORIO',
    }, {
        domanda: 'Lo è la tibia',
        risposta: 'FRIZZANTE',
    }, {
        domanda: 'Si mangia prima del secondo piatto',
        risposta: 'OSSO',
    }, {
        domanda: 'Si mangia dopo il secondo piatto',
        risposta: 'PRIMO PIATTO',
    }, {
        domanda: 'Si beve dopo il caffè',
        risposta: 'DOLCE',
    }, {
        domanda: 'Strumento di morte usato per tagliare la testa',
        risposta: 'AMMAZZACAFFÈ',
    }, {
        domanda: 'Si usa per radersi',
        risposta: 'GHIGLIOTTINA',
    }, {
        domanda: 'Strumento usato per sbattere le uova',
        risposta: 'LAMETTA',
    }, {
        domanda: 'Si regala alla festa della donna',
        risposta: 'FRUSTA',
    }, {
        domanda: 'Insetto che uccide il partner',
        risposta: 'MIMOSA',
    }, {
        domanda: 'Altro modo di dire gatto',
        risposta: 'MANTIDE',
    }, {
        domanda: 'Grande pesce predatore protagonista di numerosi film',
        risposta: 'MICIO',
    }],
    //Lista 27
    [{
        domanda: 'In che anno viene scoperta l\'America?',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Cosa vuole dire "thousand" in inglese?',
        risposta: '1942',
    }, {
        domanda: 'Chi è il regista di Psycho?',
        risposta: 'MILLE',
    }, {
        domanda: 'Mancina è sinonimo di..?',
        risposta: 'HITCHCOCK',
    }, {
        domanda: 'La prua della nave è davanti o dietro?',
        risposta: 'SINISTRA',
    }, {
        domanda: 'La coda del cavallo è davanti o dietro?',
        risposta: 'DAVANTI',
    }, {
        domanda: 'Cosa fa la terra attorno al Sole?',
        risposta: 'DIETRO',
    }, {
        domanda: 'Pasta a strati alla bolognese',
        risposta: 'GIRA',
    }, {
        domanda: 'Come si traduce in italiano je t\'aime?',
        risposta: 'LASAGNE',
    }, {
        domanda: 'Nei film cosa si dicono due spadaccini prima di battersi?',
        risposta: 'TI AMO',
    }, {
        domanda: 'In quale nazione è Bruxelles?',
        risposta: 'IN GUARDIA',
    }, {
        domanda: 'Gabriel Garko è considerato dalle donne bello o brutto?',
        risposta: 'BELGIO',
    }, {
        domanda: 'Giulio Cesare scrisse il “.. ..... Gallico”',
        risposta: 'BELLO',
    }, {
        domanda: 'Secondo il proverbio cosa fa il troppo?',
        risposta: 'DE BELLO',
    }, {
        domanda: 'Che cognome aveva Sandro, Presidente della Repubblica?',
        risposta: 'STROPPIA',
    }],
    //Lista 28
    [{
        domanda: 'Si schierano in battaglia',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Rappresenta l\'Italia negli sport',
        risposta: 'TRUPPE',
    }, {
        domanda: 'Il vino può essere frizzante oppure..?',
        risposta: 'NAZIONALE',
    }, {
        domanda: 'Lo dice chi viene ringraziato',
        risposta: 'FERMO',
    }, {
        domanda: 'Lo usano gli anziani per sorreggersi',
        risposta: 'PREGO',
    }, {
        domanda: 'Usato per forare i muri',
        risposta: 'BASTONE',
    }, {
        domanda: 'Si inserisce nella vagina durante il cliclo',
        risposta: 'TRAPANO',
    }, {
        domanda: 'Caratteristica di chi affronta senza paura le cose',
        risposta: 'ASSORBENTE',
    }, {
        domanda: 'Ciabatte da camera',
        risposta: 'CORAGGIO',
    }, {
        domanda: 'Oggetto di studio degli ornitologi',
        risposta: 'PANTOFOLE',
    }, {
        domanda: 'Escono dalla bocca di chi mente',
        risposta: 'UCCELLI',
    }, {
        domanda: 'Le si paga allo stato',
        risposta: 'BUGIE',
    }, {
        domanda: 'Re sono ricche le carni',
        risposta: 'TASSE',
    }, {
        domanda: 'Si possono fare al vapore',
        risposta: 'PROTEINE',
    }, {
        domanda: 'Navigano',
        risposta: 'VERDURE',
    }],
    //Lista 29
    [{
        domanda: 'Sono colorate quelle del pappagallo',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il significato di Beatles in italiano',
        risposta: 'PIUME',
    }, {
        domanda: 'Nel latte a colazione',
        risposta: 'SCARAFAGGI',
    }, {
        domanda: 'Vi crescono le piante',
        risposta: 'CEREALI',
    }, {
        domanda: 'Dopo la morte per le persone buone',
        risposta: 'TERRA',
    }, {
        domanda: 'Ne fa parte il Congo',
        risposta: 'PARADISO',
    }, {
        domanda: 'Lo stato del Bordeaux',
        risposta: 'AFRICA',
    }, {
        domanda: 'Il pianeta con gli anelli',
        risposta: 'FRANCIA',
    }, {
        domanda: 'Una persona che non sta attenta',
        risposta: 'SATURNO',
    }, {
        domanda: 'Lo era Elisabetta Canalis a Striscia la Notizia',
        risposta: 'DISTRATTA',
    }, {
        domanda: 'Il materiale della medaglia del terzo posto',
        risposta: 'VELINA',
    }, {
        domanda: 'Piatto di brodo e carne asiatico',
        risposta: 'RAME',
    }, {
        domanda: 'La residenza del Presidente americano',
        risposta: 'RAMEN',
    }, {
        domanda: 'Palazzo molto alto',
        risposta: 'CASA BIANCA',
    }, {
        domanda: 'Li facciamo orbitare attorno al nostro pianeta',
        risposta: 'GRATTACIELO',
    }],
    //Lista 30
    [{
        domanda: 'Vegetale che se mangiato fa puzzare la pipì',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Nell\'ano per lubrificare e favorire la penetrazione',
        risposta: 'ASPARAGO',
    }, {
        domanda: 'Identificava la posizione sociale di un indiano',
        risposta: 'VASELLINA',
    }, {
        domanda: 'Lo era Cicciolina',
        risposta: 'CASTA',
    }, {
        domanda: 'Il Gerri della televisione italiana',
        risposta: 'PORNOSTAR',
    }, {
        domanda: 'Vegetali non ancora maturi',
        risposta: 'SCOTTI',
    }, {
        domanda: 'Passati a miglior vita',
        risposta: 'ACERBI',
    }, {
        domanda: 'Fanno le fusa',
        risposta: 'MORTI',
    }, {
        domanda: 'Girano intorno al nucleo dell\'atomo',
        risposta: 'GATTI',
    }, {
        domanda: 'Ascoltano metal',
        risposta: 'ELETTRONI',
    }, {
        domanda: 'Quadri composti di piccoli tasselli colorati',
        risposta: 'METALLARI',
    }, {
        domanda: 'Li usiamo per respirare',
        risposta: 'MOSAICI',
    }, {
        domanda: 'Sono il feticismo sessuale di molti uomini',
        risposta: 'POLMONI',
    }, {
        domanda: 'Lo è quella taragna',
        risposta: 'PIEDI',
    }, {
        domanda: 'Capoluogo della Basilicata',
        risposta: 'POLENTA',
    }],
    //Lista 31
    [{
        domanda: 'Corrono nella ruota',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Fritti ad anelli',
        risposta: 'CRICETI',
    }, {
        domanda: 'Se trovato in un prato porta fortuna',
        risposta: 'CALAMARI',
    }, {
        domanda: 'Contiene contanti e tessere',
        risposta: 'QUADRIFOGLIO',
    }, {
        domanda: 'Il formato classico del foglio da stampante',
        risposta: 'PORTAFOGLIO',
    }, {
        domanda: 'Strada dei percorsi montani',
        risposta: 'A4',
    }, {
        domanda: 'La attraversano i Beatles',
        risposta: 'SENTIERO',
    }, {
        domanda: 'In casa per correre',
        risposta: 'STRADA',
    }, {
        domanda: 'La mozzarella tra le fette di pane fritte',
        risposta: 'TAPIS ROULANT',
    }, {
        domanda: 'Ci va il minatore',
        risposta: 'IN CARROZZA',
    }, {
        domanda: 'Immediatamente prima del mare, con la sabbia',
        risposta: 'MINIERA',
    }, {
        domanda: 'Ci cammina il fachiro',
        risposta: 'SPIAGGIA',
    }, {
        domanda: 'Accessorio femminile per capelli, a ferro di cavallo',
        risposta: 'CHIODI',
    }, {
        domanda: 'Lo chiede la mafia',
        risposta: 'CERCHIETTO',
    }, {
        domanda: 'Con le chele, cammina di lato',
        risposta: 'PIZZO',
    }],
    //Lista 32
    [{
        domanda: 'Il gesto calcistico di scartare gli avversari',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Sinonimo di ira',
        risposta: 'DRIBBLING',
    }, {
        domanda: 'Vi defeca il bebè',
        risposta: 'RABBIA',
    }, {
        domanda: 'Superficie di lavoro in ufficio',
        risposta: 'PANNOLONE',
    }, {
        domanda: 'Tutte le feste si porta via',
        risposta: 'SCRIVANIA',
    }, {
        domanda: 'Il miracolo per cui Gesù ritorna alla vita',
        risposta: 'EPIFANIA',
    }, {
        domanda: 'Quando il membro si ingrossa',
        risposta: 'RESURREZIONE',
    }, {
        domanda: 'La reazione del pubblico dopo una bella performance',
        risposta: 'EREZIONE',
    }, {
        domanda: 'Lo assegna l\'insegnante allo studente come valutazione',
        risposta: 'APPLAUSO',
    }, {
        domanda: 'Il nome del don Corleone',
        risposta: 'VOTO',
    }, {
        domanda: 'Nome di Clinton',
        risposta: 'VITO',
    }, {
        domanda: 'Nome di Renzi',
        risposta: 'BILL',
    }, {
        domanda: 'Animale erbivoro dal collo lungo',
        risposta: 'MATTEO',
    }, {
        domanda: 'Simbolo del brand Puma',
        risposta: 'GIRAFFA',
    }, {
        domanda: 'Ricopre il tronco degli alberi',
        risposta: 'PUMA',
    }],
    //Lista 33
    [{
        domanda: 'Grandi mezzi a quattro ruote per trasporto merci',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Detta anche serranda',
        risposta: 'CAMION',
    }, {
        domanda: 'Chiude la bottiglia',
        risposta: 'TAPPARELLA',
    }, {
        domanda: 'Una persona che balbetta',
        risposta: 'TAPPO',
    }, {
        domanda: 'Si contrappone al bene',
        risposta: 'BALBUZIENTE',
    }, {
        domanda: 'Si fa a letto con il proprio partner',
        risposta: 'MALE',
    }, {
        domanda: 'Diesel oppure..?',
        risposta: 'SESSO',
    }, {
        domanda: 'Bevuta in Russia, fa ubriacare',
        risposta: 'BENZINA',
    }, {
        domanda: 'Barrisce',
        risposta: 'VODKA',
    }, {
        domanda: 'Nitrisce',
        risposta: 'ELEFANTE',
    }, {
        domanda: 'Bela',
        risposta: 'CAVALLO',
    }, {
        domanda: 'Gracida',
        risposta: 'PECORA',
    }, {
        domanda: 'Si esprime in rime sopra un beat',
        risposta: 'RANA',
    }, {
        domanda: 'Il fiume più lungo del mondo',
        risposta: 'RAPPER',
    }, {
        domanda: 'Il pesciolino arancione della Disney',
        risposta: 'NILO',
    }],
    //Lista 34
    [{
        domanda: 'Di visone o altri animali',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Dà energia agli elettrodomestici',
        risposta: 'PELLICCIA',
    }, {
        domanda: 'Si prova per chi si detesta',
        risposta: 'ELETTRICITÀ',
    }, {
        domanda: 'Determina ipertensione o ipotensione',
        risposta: 'ODIO',
    }, {
        domanda: 'Gesto di gioia dopo un goal',
        risposta: 'PRESSIONE',
    }, {
        domanda: 'Si fa con "cin cin"',
        risposta: 'ESULTANZA',
    }, {
        domanda: 'Capoluogo della Puglia',
        risposta: 'BRINDISI',
    }, {
        domanda: 'Ci si va a bere un caffè',
        risposta: 'BARI',
    }, {
        domanda: 'Antico luogo di culto greco',
        risposta: 'BAR',
    }, {
        domanda: 'Determinato in secondi, minuti, ecc.',
        risposta: 'TEMPIO',
    }, {
        domanda: 'La stagione prima dell\'inverno',
        risposta: 'TEMPO',
    }, {
        domanda: 'La stagione prima della primavera',
        risposta: 'AUTUNNO',
    }, {
        domanda: 'Momento in cui il bimbo esce dalla pancia',
        risposta: 'INVERNO',
    }, {
        domanda: 'Vi si parcheggiano le barche',
        risposta: 'PARTO',
    }, {
        domanda: 'Vi lavorano gli insegnanti',
        risposta: 'PORTO',
    }],
    //Lista 35
    [{
        domanda: 'Sono Homer, Marge, Lisa, Bart e Maggie',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il cognome di Italo scrittore',
        risposta: 'SIMPSON',
    }, {
        domanda: 'Con i sette nani',
        risposta: 'CALVINO',
    }, {
        domanda: 'Detta anche "bamba"',
        risposta: 'BIANCANEVE',
    }, {
        domanda: 'Altro nome del grano',
        risposta: 'COCAINA',
    }, {
        domanda: 'Il famoso "Tenente" del telefilm americano',
        risposta: 'FRUMENTO',
    }, {
        domanda: 'Si applica sulla busta postale',
        risposta: 'COLOMBO',
    }, {
        domanda: 'Unità di misura della potenza visiva',
        risposta: 'FRANCOBOLLO',
    }, {
        domanda: 'La posizione ottenuta degli azzuri ai mondiali di calcio 2006',
        risposta: 'DECIMI',
    }, {
        domanda: 'Saranno i primi',
        risposta: 'PRIMI',
    }, {
        domanda: 'Indossano i guantoni',
        risposta: 'ULTIMI',
    }, {
        domanda: 'Li tira in barca chi rinuncia ad una impresa',
        risposta: 'PUGILI',
    }, {
        domanda: 'Attrezzi, strumenti di lavoro',
        risposta: 'REMI',
    }, {
        domanda: 'Gli gnomi azzurri dei cartoni animati',
        risposta: 'UTENSILI',
    }, {
        domanda: 'Tra i due, il terzo gode',
        risposta: 'PUFFI',
    }],
    //Lista 36
    [{
        domanda: 'Ai piedi dei tedeschi con i calzini',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Costruiscono dighe nei ruscelli',
        risposta: 'SANDALI',
    }, {
        domanda: 'Perdono i denti da latte',
        risposta: 'CASTORI',
    }, {
        domanda: 'Sono stati tolti agli evirati',
        risposta: 'BAMBINI',
    }, {
        domanda: 'Non credono in nessun Dio',
        risposta: 'COGLIONI',
    }, {
        domanda: 'Mangiano solo carne halal',
        risposta: 'ATEI',
    }, {
        domanda: 'Di essi "non si butta via niente"',
        risposta: 'MUSULMANI',
    }, {
        domanda: 'Sopra alle fragole',
        risposta: 'MAIALI',
    }, {
        domanda: 'Pompa il sangue',
        risposta: 'PANNA',
    }, {
        domanda: 'Lo si lancia agli sposi',
        risposta: 'CUORE',
    }, {
        domanda: 'Se è di sera bel tempo si spera',
        risposta: 'RISO',
    }, {
        domanda: 'Il titolo conferito a Silvio Berlusconi',
        risposta: 'ROSSO',
    }, {
        domanda: 'Ha gli stivali nella fiaba',
        risposta: 'CAVALIERE',
    }, {
        domanda: 'Lo si mangia allo spiedo',
        risposta: 'GATTO',
    }, {
        domanda: 'Suona rullante, tom, grancassa e piatti',
        risposta: 'POLLO',
    }],
    //Lista 37
    [{
        domanda: 'Si suona con l\'archetto e appoggiandoci il mento',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il colore del fascismo',
        risposta: 'VIOLINO',
    }, {
        domanda: 'Si occupa dell\'apparato sessuale femminile',
        risposta: 'NERO',
    }, {
        domanda: 'Il costume carnevalesco più celebre',
        risposta: 'GINECOLOGO',
    }, {
        domanda: 'Giardino di siepi in cui ci si perde',
        risposta: 'ARLECCHINO',
    }, {
        domanda: 'Lo è il San Paolo di Napoli',
        risposta: 'LABIRINTO',
    }, {
        domanda: 'La spina che regge in piedi un umano',
        risposta: 'STADIO',
    }, {
        domanda: 'Lo leggono i sordi nel volto di chi parla',
        risposta: 'DORSALE',
    }, {
        domanda: 'Sesso orale eseguito sull\'uomo',
        risposta: 'LABIALE',
    }, {
        domanda: 'Convoglia e distribuisce l\'acqua',
        risposta: 'POMPINO',
    }, {
        domanda: 'Nietzsche',
        risposta: 'ACQUEDOTTO',
    }, {
        domanda: 'Ripara le tubature',
        risposta: 'FILOSOFO',
    }, {
        domanda: 'Spregiativamente detto frocio, buliccio, finocchio',
        risposta: 'IDRAULICO',
    }, {
        domanda: 'Se abbaia, non morde',
        risposta: 'OMOSESSUALE',
    }, {
        domanda: 'Il re della savana',
        risposta: 'CANE',
    }],
    //Lista 38
    [{
        domanda: 'Momento in cui sorge il sole',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Pianta di mare utilizzata nel sushi',
        risposta: 'ALBA',
    }, {
        domanda: 'Sostanza secreta dal condotto uditivo',
        risposta: 'ALGA',
    }, {
        domanda: 'È brulè',
        risposta: 'CERUME',
    }, {
        domanda: 'Distillato all\'anice ad alta gradazione',
        risposta: 'VIN',
    }, {
        domanda: 'Il Galilei scienziato',
        risposta: 'ASSENZIO',
    }, {
        domanda: 'Accudisce il bambino in assenza del genitore',
        risposta: 'GALILEO',
    }, {
        domanda: 'Si lancia in acqua da un trampolino',
        risposta: 'BABYSITTER',
    }, {
        domanda: 'Suona al mattino',
        risposta: 'TUFFATORE',
    }, {
        domanda: 'Difficoltà a defecare',
        risposta: 'SVEGLIA',
    }, {
        domanda: 'Lavorazione del terreno propedeutica alla coltivazione',
        risposta: 'STITICHEZZA',
    }, {
        domanda: 'Rimozione dei peli',
        risposta: 'ARATURA',
    }, {
        domanda: 'Alcuni al mare la fanno in acqua',
        risposta: 'DEPILAZIONE',
    }, {
        domanda: 'Bevanda consumata in compagnia prima di un pasto',
        risposta: 'PIPÌ',
    }, {
        domanda: 'Conclude la vita',
        risposta: 'APERITIVO',
    }],
    //Lista 39
    [{
        domanda: 'Ne sono ricchi i legumi',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Per disegnare linee dritte',
        risposta: 'PROTEINE',
    }, {
        domanda: 'È d\'Achille il punto debole',
        risposta: 'RIGHELLO',
    }, {
        domanda: 'Preso a calci da Totti',
        risposta: 'TALLONE',
    }, {
        domanda: 'Il celebre gioco d\'azzardo cinese',
        risposta: 'PALLONE',
    }, {
        domanda: 'Si ammucchia sulle superfici nel tempo',
        risposta: 'MORRA',
    }, {
        domanda: 'La celebre tecnica "..su tela" nella pittura',
        risposta: 'POLVERE',
    }, {
        domanda: 'Se lo mettono i giovani sul spracciglio, labbro, naso, ecc.',
        risposta: 'OLIO',
    }, {
        domanda: 'Mostra i seni delle donne in un indumento',
        risposta: 'PIERCING',
    }, {
        domanda: 'Lo era una farfalla',
        risposta: 'SCOLLATURA',
    }, {
        domanda: 'Quello del culo',
        risposta: 'BACO',
    }, {
        domanda: 'Viene praticato durante il Ramadan',
        risposta: 'BUCO',
    }, {
        domanda: 'Appuntito, per cucire i tessuti',
        risposta: 'DIGIUNO',
    }, {
        domanda: 'Insegue il criminale',
        risposta: 'AGO',
    }, {
        domanda: 'Non fa primavera',
        risposta: 'POLIZIOTTO',
    }],
    //Lista 40
    [{
        domanda: 'Fa uscire il fumo da una casa',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'La Miuccia della moda',
        risposta: 'CAMINO',
    }, {
        domanda: 'Si suona per chiedere di entrare',
        risposta: 'PRADA',
    }, {
        domanda: 'Scientifico o classico',
        risposta: 'CAMPANELLO',
    }, {
        domanda: 'Mezzo a spinta a due ruote',
        risposta: 'LICEO',
    }, {
        domanda: 'Polare artico',
        risposta: 'MONOPATTINO',
    }, {
        domanda: 'Con cinque lati',
        risposta: 'CIRCOLO',
    }, {
        domanda: 'Ci vive George Clooney in Italia',
        risposta: 'PENTAGONO',
    }, {
        domanda: 'Il territorio di Mowgli',
        risposta: 'LAGO DI COMO',
    }, {
        domanda: 'La figlia di mio padre',
        risposta: 'GIUNGLA',
    }, {
        domanda: 'La madre di mio padre',
        risposta: 'SORELLA',
    }, {
        domanda: 'Pigola',
        risposta: 'NONNA',
    }, {
        domanda: 'Fatto morire per una divinità',
        risposta: 'PULCINO',
    }, {
        domanda: 'Concentrato, assorto, grave',
        risposta: 'SACRIFICATO',
    }, {
        domanda: 'È meglio di avercelo corto',
        risposta: 'SERIO',
    }],
    //Lista 41
    [{
        domanda: 'Gioco di carte con i "carichi"',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Si ha sopra i 37.5 gradi',
        risposta: 'BRISCOLA',
    }, {
        domanda: 'Ne ha timore chi è aracnofobo',
        risposta: 'FEBBRE',
    }, {
        domanda: 'Sinonimo di loffe',
        risposta: 'RAGNI',
    }, {
        domanda: 'Le escargot',
        risposta: 'SCORREGGE',
    }, {
        domanda: 'Nel deserto con le spine',
        risposta: 'LUMACHE',
    }, {
        domanda: 'Granelli di semola di frumento al vapore',
        risposta: 'CACTUS',
    }, {
        domanda: 'Il veterano interpretato da Sylvester Stallone',
        risposta: 'COUS COUS',
    }, {
        domanda: 'Sinonimo di dizionario',
        risposta: 'RAMBO',
    }, {
        domanda: 'Ne era un virtuoso Miles Davis',
        risposta: 'VOCABOLARIO',
    }, {
        domanda: 'Lo fa di mestiere Rocco Siffredi',
        risposta: 'TROMBA',
    }, {
        domanda: 'Mangia tradizionalmente il pane Naan',
        risposta: 'PORNOATTORE',
    }, {
        domanda: 'Lo è il "Ciao"',
        risposta: 'INDIANO',
    }, {
        domanda: 'Medico dell\'orecchio',
        risposta: 'MOTORINO',
    }, {
        domanda: 'Si nutre di formiche',
        risposta: 'OTORINO',
    }],
    //Lista 42
    [{
        domanda: 'Charmander, Bulbasaur e Squirtle',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Gira intero sullo spiedo',
        risposta: 'POKÉMON',
    }, {
        domanda: 'La parte della scarpa che aderisce al terreno',
        risposta: 'POLLO',
    }, {
        domanda: 'I bambini ci devono andare ogni mattina',
        risposta: 'SUOLA',
    }, {
        domanda: 'Locale in cui talvolta un nastro trasporta il cibo',
        risposta: 'SCUOLA',
    }, {
        domanda: 'Gianni e Donatella',
        risposta: 'SUSHI',
    }, {
        domanda: 'Chi desidera cose d\'altri',
        risposta: 'VERSACE',
    }, {
        domanda: 'Infuso calmante a base di fiori',
        risposta: 'INVIDIOSO',
    }, {
        domanda: 'Usato per contrastare l\'astinenza da oppioidi',
        risposta: 'CAMOMILLA',
    }, {
        domanda: 'Nell\'amatriciana insieme al pomodoro',
        risposta: 'METADONE',
    }, {
        domanda: 'La hanno gli uomini sotto il naso',
        risposta: 'PANCETTA',
    }, {
        domanda: 'Vi si trasportano i feriti',
        risposta: 'BAFFI',
    }, {
        domanda: 'Pavimentazione tradizionale giapponese',
        risposta: 'BARELLA',
    }, {
        domanda: 'Il cognome di Pippo presentatore',
        risposta: 'TATAMI',
    }, {
        domanda: 'Il cane amico di Pippo',
        risposta: 'BAUDO',
    }],
    //Lista 43
    [{
        domanda: 'Gli spaghetti cinesi',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Ne può essere fatto un castello per gioco',
        risposta: 'NOODLES',
    }, {
        domanda: 'Il cortile interno di una abitazione',
        risposta: 'CARTE',
    }, {
        domanda: 'Ci giochi a poker',
        risposta: 'CORTE',
    }, {
        domanda: 'Cessione di beni con impegno alla restituzione',
        risposta: 'CARTE',
    }, {
        domanda: 'Tiene il segno su una pagina di interesse',
        risposta: 'PRESTITO',
    }, {
        domanda: 'Lo strumento del deejay',
        risposta: 'SEGNALIBRO',
    }, {
        domanda: 'Vi si cucina un arrosto',
        risposta: 'CONSOLE',
    }, {
        domanda: 'Permette di respirare nello snorkeling',
        risposta: 'FORNO',
    }, {
        domanda: 'Autore del Decameron',
        risposta: 'BOCCAGLIO',
    }, {
        domanda: 'Il labbro con malformazione a fessura',
        risposta: 'BOCCACCIO',
    }, {
        domanda: 'Simile al coniglio, molto agile',
        risposta: 'LEPORINO',
    }, {
        domanda: 'Persona affetta da stato uno di tristezza continua',
        risposta: 'LEPRE',
    }, {
        domanda: 'Formaggio con i buchi',
        risposta: 'DEPRESSO',
    }, {
        domanda: 'Causa una pelle butterata',
        risposta: 'EMMENTAL',
    }],
    //Lista 44
    [{
        domanda: 'Studiano a scuola',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Li abbiamo per lacerare il cibo',
        risposta: 'STUDENTI',
    }, {
        domanda: 'Animale domestico, di terra o di mare',
        risposta: 'CANINI',
    }, {
        domanda: 'I muscoli del petto',
        risposta: 'TARTARUGA',
    }, {
        domanda: 'Sono prelibate quelle del pollo',
        risposta: 'PETTORALI',
    }, {
        domanda: 'Sotto ai piedi per scivolare sulla neve',
        risposta: 'COSCE',
    }, {
        domanda: 'Francesco er pupone',
        risposta: 'SCI',
    }, {
        domanda: 'Il Profeta musulmano',
        risposta: 'TOTTI',
    }, {
        domanda: 'Il dito più piccolo',
        risposta: 'MAOMETTO',
    }, {
        domanda: 'Il dito del vaffanculo',
        risposta: 'MIGNOLO',
    }, {
        domanda: 'Michael Jordan era considerato scarso o forte?',
        risposta: 'MEDIO',
    }, {
        domanda: 'Radicalmente convinto della propria superiorità',
        risposta: 'FORTE',
    }, {
        domanda: 'L\'identità segreta di Clark Kent',
        risposta: 'SUPERBO',
    }, {
        domanda: 'Il chirurgo che ti fa la plastica',
        risposta: 'SUPERMAN',
    }, {
        domanda: 'Sinonimo di chiatto',
        risposta: 'ESTETICO',
    }],
    //Lista 45
    [{
        domanda: 'Di quale regione sono tipici gli arrosticini?',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il nome d\'arte del cantante Fornaciari',
        risposta: 'ABRUZZO',
    }, {
        domanda: 'Nell\'acqua della pasta, grosso o fino',
        risposta: 'ZUCCHERO',
    }, {
        domanda: 'Cosa fa la funivia dalla pianura alla cima: sale o scende?',
        risposta: 'SALE',
    }, {
        domanda: 'Quanto è il voltaggio della corrente elettrica in Italia?',
        risposta: 'SALE',
    }, {
        domanda: 'Quanto fa 20 per 22?',
        risposta: '220',
    }, {
        domanda: 'Quanti erano i soldati di Marsala con Garibaldi?',
        risposta: '440',
    }, {
        domanda: 'Quante sono le miglia della famosa corsa d\'auto d\'epoca?',
        risposta: 'MILLE',
    }, {
        domanda: 'Il ciclista amico e rivale di Coppi',
        risposta: 'MILLE',
    }, {
        domanda: 'Eravamo quattro amici al..?',
        risposta: 'BARTALI',
    }, {
        domanda: 'Ci lavora chi ti affetta il prosciutto',
        risposta: 'BAR',
    }, {
        domanda: 'La nazione della precisione',
        risposta: 'SALUMERIA',
    }, {
        domanda: 'Ha per capitale Berna',
        risposta: 'SVIZZERA',
    }, {
        domanda: 'Sport a squadre dove ci si passa la palla oltre una rete',
        risposta: 'SVIZZERA',
    }, {
        domanda: 'Alcolico al limone',
        risposta: 'PALLAVOLO',
    }],
    //Lista 46
    [{
        domanda: 'Il gioco con il Parco della Vittoria',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Quelli di stato tassano i tabacchi',
        risposta: 'MONÒPOLI',
    }, {
        domanda: 'Comune dove si parla il dialetto monopolitano',
        risposta: 'MONOPÒLI',
    }, {
        domanda: 'Ha avuto un figlio con Balotelli',
        risposta: 'MONÒPOLI',
    }, {
        domanda: 'Era chiamata la Pulzella d\'Orleans',
        risposta: 'RAFFAELLA FICO',
    }, {
        domanda: 'Il primo presidente nero americano',
        risposta: 'GIOVANNA D\'ARCO',
    }, {
        domanda: 'Il marito di Michelle Obama',
        risposta: 'BARACK OBAMA',
    }, {
        domanda: 'È moglie di Barack Obama',
        risposta: 'BARACK OBAMA',
    }, {
        domanda: 'Nome del cantante napoletano D\'Alessio',
        risposta: 'MICHELLE OBAMA',
    }, {
        domanda: 'Nome dell\'inventore e artista Da Vinci',
        risposta: 'GIGI',
    }, {
        domanda: 'Il maschio della leonessa',
        risposta: 'LEONARDO',
    }, {
        domanda: 'Sergio, regista western',
        risposta: 'LEONE',
    }, {
        domanda: 'Lo è Woody Woodpecker',
        risposta: 'LEONE',
    }, {
        domanda: 'Capoluogo del Veneto',
        risposta: 'PICCHIO',
    }, {
        domanda: 'Quanti erano i gatti in fila per tre?',
        risposta: 'VENEZIA',
    }],
    //Lista 47
    [{
        domanda: 'Il nome del Pascal di Pirandello',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il mese del Carnevale',
        risposta: 'MATTIA',
    }, {
        domanda: 'Ginger in italiano',
        risposta: 'FEBBRAIO',
    }, {
        domanda: 'Ronza e ti punge d\'estate',
        risposta: 'ZENZERO',
    }, {
        domanda: 'L\'animale con la proboscide',
        risposta: 'ZANZARA',
    }, {
        domanda: 'L\'animale con le chele',
        risposta: 'ELEFANTE',
    }, {
        domanda: 'Prima di Turismo in un videogioco di corse',
        risposta: 'GRANCHIO',
    }, {
        domanda: 'Prima di Padano nel nome di un formaggio',
        risposta: 'GRAN',
    }, {
        domanda: 'Prataioli, chiodini, finferli',
        risposta: 'GRANA',
    }, {
        domanda: 'Ce li si pettina col pettine',
        risposta: 'FUNGHI',
    }, {
        domanda: 'Spuntano sul pube dell\'adolescente',
        risposta: 'CAPELLI',
    }, {
        domanda: 'Si mangiano col vin santo',
        risposta: 'PELI',
    }, {
        domanda: 'Tipici uccelli canterini',
        risposta: 'CANTUCCI',
    }, {
        domanda: 'Si fanno schioccare per tenere il tempo',
        risposta: 'CANARINI',
    }, {
        domanda: 'Si battono per applaudire',
        risposta: 'DITA',
    }],
    //Lista 48
    [{
        domanda: 'Ha per capitale Camberra ed è piena di canguri',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Ha per capitale Vienna ed è piena di knödel',
        risposta: 'AUSTRALIA',
    }, {
        domanda: 'Significa “a tua sorella” in napoletano',
        risposta: 'AUSTRIA',
    }, {
        domanda: 'Si dice per ringraziare',
        risposta: 'SORETA',
    }, {
        domanda: 'Maurizio, presentatore televisivo',
        risposta: 'GRAZIE',
    }, {
        domanda: 'La selva del cammin di nostra vita',
        risposta: 'COSTANZO',
    }, {
        domanda: 'Com\'è la faccia di una persona che ti sta antipatica?',
        risposta: 'OSCURA',
    }, {
        domanda: 'Il leader drogato dei Nirvana',
        risposta: 'DI MERDA',
    }, {
        domanda: 'L\'orsacchiotto a cui si sono ispirati i Pooh per il nome',
        risposta: 'KURT COBAIN',
    }, {
        domanda: 'Tira più di un carro di buoi',
        risposta: 'WINNIE',
    }, {
        domanda: 'Si chiede e si da su Facebook',
        risposta: 'PELO DI FIGA',
    }, {
        domanda: 'Si rischia tra Gran Bretagna e Argentina per le Falkland',
        risposta: 'AMICIZIA',
    }, {
        domanda: 'David, famoso DJ francese',
        risposta: 'GUERRA',
    }, {
        domanda: 'Nome del famoso DJ Sinclair',
        risposta: 'GUETTA',
    }, {
        domanda: 'Sport invernale a due o a quattro',
        risposta: 'BOB',
    }],
    //Lista 49
    [{
        domanda: 'Il genere musicale di Bob Marley',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il salvatelecomando lo protegge',
        risposta: 'REGGAE',
    }, {
        domanda: 'Dopo caffè e ammazzacaffè',
        risposta: 'TELECOMANDO',
    }, {
        domanda: 'Quello di Montecristo è descritto da Dumas',
        risposta: 'CONTO',
    }, {
        domanda: 'La modalità di sorteggio nei giochi dei bambini',
        risposta: 'CONTE',
    }, {
        domanda: 'È sbagliato farli senza l\'oste',
        risposta: 'CONTA',
    }, {
        domanda: 'Le passò Annibale con gli elefanti',
        risposta: 'CONTI',
    }, {
        domanda: 'Cantena montuosa che percorre l\'Italia da nord a sud',
        risposta: 'ALPI',
    }, {
        domanda: 'Sono grandi quelli delle maggiorate',
        risposta: 'APPENNINI',
    }, {
        domanda: 'Si stringono presentandosi',
        risposta: 'SENI',
    }, {
        domanda: 'Si infilano nelle scarpe',
        risposta: 'MANI',
    }, {
        domanda: 'Si collezionano e si leccano per utilizzarli',
        risposta: 'PIEDI',
    }, {
        domanda: 'Compongono un arcipelago',
        risposta: 'FRANCOBOLLI',
    }, {
        domanda: 'La prima parola dell\'inno di Mameli',
        risposta: 'ISOLE',
    }, {
        domanda: 'Lo sono Batman e Joker',
        risposta: 'FRATELLI',
    }],
    //Lista 50
    [{
        domanda: 'Il Roberto attore toscano',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il cibo del formichiere',
        risposta: 'BENIGNI',
    }, {
        domanda: 'Barriscono',
        risposta: 'FORMICHE',
    }, {
        domanda: 'Fanno primavera ma solo se in quantità',
        risposta: 'ELEFANTI',
    }, {
        domanda: 'A quelle padane piace andare in giro a controllare',
        risposta: 'RONDINI',
    }, {
        domanda: 'Fanno il rumore “prot”',
        risposta: 'RONDE',
    }, {
        domanda: 'Le cacciano le baleniere',
        risposta: 'SCORREGGE',
    }, {
        domanda: 'Sfilano in passerella',
        risposta: 'BALENE',
    }, {
        domanda: 'Ti chiedono il pizzo se hai un\'attività',
        risposta: 'MODELLE',
    }, {
        domanda: 'Diplomatici che rappresentano una nazione all\'estero',
        risposta: 'MAFIE',
    }, {
        domanda: 'Hanno le pecore in spalle nel Presepe',
        risposta: 'AMBASCIATORI',
    }, {
        domanda: 'Ti preparano i cocktail',
        risposta: 'PASTORI',
    }, {
        domanda: 'Ti preparano la cena',
        risposta: 'BARMAN',
    }, {
        domanda: 'Sono d\'artificio quelli che esplodono in cielo',
        risposta: 'CUOCHI',
    }, {
        domanda: 'Seguono Saviano ovunque vada',
        risposta: 'FUOCHI',
    }],
    //Lista 51
    [{
        domanda: 'Il nome di questo quiz',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Le Egadi, le Eolie e le Falkland',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Le Alpi, le Ande, i Pirenei',
        risposta: 'ISOLE',
    }, {
        domanda: 'C\'è l\'obbligo in auto in caso di neve o ghiaccio',
        risposta: 'MONTI',
    }, {
        domanda: 'Se hai la gengivite sanguinano',
        risposta: 'CATENE',
    }, {
        domanda: 'Le donne se le depilano per essere più attraenti',
        risposta: 'GENGIVE',
    }, {
        domanda: 'Sono dette “Safety” nella Formula 1',
        risposta: 'GAMBE',
    }, {
        domanda: 'Va sulle piste ciclabili',
        risposta: 'CAR',
    }, {
        domanda: 'Tipico aperitivo prosecco e bitter',
        risposta: 'BICICLETTA',
    }, {
        domanda: 'Lo dicono molte persone nel momento dell\'orgasmo',
        risposta: 'SPRITZ',
    }, {
        domanda: 'Segnale che si lancia nelle emergenze',
        risposta: 'VENGO',
    }, {
        domanda: 'Tradizionale tipologia di pasta ligure',
        risposta: 'SOS',
    }, {
        domanda: 'Le tipiche impurità sul viso degli adolescenti',
        risposta: 'TROFIE',
    }, {
        domanda: 'Lo sono quelle del Niagara',
        risposta: 'BRUFOLI',
    }, {
        domanda: 'Le sorelle del tennis USA',
        risposta: 'CASCATE',
    }],
    //Lista 52
    [{
        domanda: 'Si sono riuniti a Roma per il conclave',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Perni incernierati su stipiti di porte e finestre',
        risposta: 'CARDINALI',
    }, {
        domanda: 'Piccole parti di escrementi attaccate ai peli del buso',
        risposta: 'CARDINI',
    }, {
        domanda: 'Violenti cicloni tropicali',
        risposta: 'TARZANELLI',
    }, {
        domanda: 'Format televisivi tipo X Factor',
        risposta: 'URAGANI',
    }, {
        domanda: 'Format televisivi tipo TG1',
        risposta: 'TALENT',
    }, {
        domanda: 'Lo si arrotola per punire affettuosamente il cane',
        risposta: 'TELEGIORNALE',
    }, {
        domanda: 'Un tubicino che può servire a bere un cocktail',
        risposta: 'GIORNALE',
    }, {
        domanda: 'Ci si aspira la polvere dal tappeto',
        risposta: 'CANNUCCIA',
    }, {
        domanda: 'Orzo e Pepsi Cola: quale non è succedaneo del caffè?',
        risposta: 'ASPIRAPOLVERE',
    }, {
        domanda: 'Può essere vergine ed extravergine',
        risposta: 'ORZO',
    }, {
        domanda: 'I free climber lo mettono sulle mani per fare presa',
        risposta: 'OLIO',
    }, {
        domanda: 'Si dà sulla bocca o sulla guancia',
        risposta: 'MAGNESIO',
    }, {
        domanda: 'Quello da seta produce la seta',
        risposta: 'BACIO',
    }, {
        domanda: 'Frutto arancione che se mangiato acerbo, allappa',
        risposta: 'BACO',
    }],
    //Lista 53
    [{
        domanda: 'Come il cacio sui..?',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Una ragazza che te la fa solo annusare è una "arriccia..”?',
        risposta: 'MACCHERONI',
    }, {
        domanda: 'Sono aguzzi quelli del vampiro',
        risposta: 'CAZZI',
    }, {
        domanda: 'Il Maestrale e il Ponente sono dei..?',
        risposta: 'DENTI',
    }, {
        domanda: '2X2',
        risposta: 'VENTI',
    }, {
        domanda: 'Quante gambe ha un bipede?',
        risposta: '4',
    }, {
        domanda: 'Quanti sono i colli di Roma?',
        risposta: '2',
    }, {
        domanda: 'Quando vuoi acqua è perchè hai..?',
        risposta: '7',
    }, {
        domanda: 'Quando vuoi cibo è perchè hai..?',
        risposta: 'SETE',
    }, {
        domanda: 'Quando vuoi dormire è perchè hai..?',
        risposta: 'FAME',
    }, {
        domanda: 'Noi siamo, voi siete, essi..?',
        risposta: 'SONNO',
    }, {
        domanda: 'La marca della PlayStation',
        risposta: 'SONO',
    }, {
        domanda: 'Il Giovanni dei ravioli',
        risposta: 'SONY',
    }, {
        domanda: 'Animale simile al coccodrillo',
        risposta: 'RANA',
    }, {
        domanda: 'Posizione sessuale classica: smorza..?',
        risposta: 'LUCERTOLA',
    }],
    //Lista 54
    [{
        domanda: 'Si usa dire: mi stai sui..?',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Si usa dire: prendere lucciole per..?',
        risposta: 'COGLIONI',
    }, {
        domanda: 'con i buoi dei paesi tuoi',
        risposta: 'LANTERNE',
    }, {
        domanda: 'Vanno al lardo e ci lasciano lo zampino',
        risposta: 'MOGLI',
    }, {
        domanda: 'Sinonimo di scarafaggi',
        risposta: 'GATTE',
    }, {
        domanda: 'Insalata, carote, pomodori sono..?',
        risposta: 'BLATTE',
    }, {
        domanda: 'Mele, pere, pesche sono..?',
        risposta: 'VERDURE',
    }, {
        domanda: 'Merluzzi, trote, sardine sono..?',
        risposta: 'FRUTTA',
    }, {
        domanda: 'I delfini sono..?',
        risposta: 'PESCI',
    }, {
        domanda: 'I serpenti sono..?',
        risposta: 'MAMMIFERI',
    }, {
        domanda: 'I granchi sono..?',
        risposta: 'RETTILI',
    }, {
        domanda: 'Gli usignoli sono..?',
        risposta: 'CROSTACEI',
    }, {
        domanda: 'Le formiche sono..?',
        risposta: 'UCCELLI',
    }, {
        domanda: 'Si usa dire: pesce grande mangia pesce..?',
        risposta: 'INSETTI',
    }, {
        domanda: 'Le donne sono contente se l\'uomo ha il pistulino..?',
        risposta: 'PICCOLO',
    }],
    //Lista 55
    [{
        domanda: 'Ti provocano un orgasmo a pagamento',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Le t-shirt in italiano',
        risposta: 'PROSTITUTE',
    }, {
        domanda: 'Si bucano col ditone del piede',
        risposta: 'MAGLIETTE',
    }, {
        domanda: 'Si annusano nel mazzo',
        risposta: 'CALZINI',
    }, {
        domanda: 'I padroni dei cani devono raccoglierli',
        risposta: 'FIORI',
    }, {
        domanda: 'Ce li si scambia nelle festività',
        risposta: 'ESCREMENTI',
    }, {
        domanda: 'Li riceve Gesù bambino dai Re Magi',
        risposta: 'AUGURI',
    }, {
        domanda: 'I nipotini di Paperino',
        risposta: 'DONI',
    }, {
        domanda: 'Se ti siedi sui mariti delle tue figlie, dove ti siedi?',
        risposta: 'QUI, QUO, QUA',
    }, {
        domanda: 'Sinonimo di lunga striscia di cocaina',
        risposta: 'GENERI',
    }, {
        domanda: 'Da dove decollavano i veicoli spaziali USA?',
        risposta: 'PISTA',
    }, {
        domanda: 'L\'indirizzo del ragazzo nella celebre canzone di Celentano',
        risposta: 'CAPE CANAVERAL',
    }, {
        domanda: 'Nelle gare infantili si dice: pronti, partenza, ..?',
        risposta: 'VIA GLUCK',
    }, {
        domanda: 'Nelle extended version, i brani sono corti o lunghi?',
        risposta: 'VIA',
    }, {
        domanda: 'Gli occhi delle belle fighe sono piccoli o grandi?',
        risposta: 'LUNGHI',
    }],
    //Lista 56
    [{
        domanda: 'Celebre quartiere di New York, con Times Square',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il drink con rum, cola e lime',
        risposta: 'MANHATTAN',
    }, {
        domanda: 'Dove operava il Che?',
        risposta: 'CUBA LIBRE',
    }, {
        domanda: 'La forma con facce di uguali dimensioni',
        risposta: 'CUBA',
    }, {
        domanda: 'L\'ano è quello del culo',
        risposta: 'CUBO',
    }, {
        domanda: 'L\'ha fatto Berlusconi per avere più capelli',
        risposta: 'BUCO',
    }, {
        domanda: 'Grave e intenzionale offesa',
        risposta: 'TRAPIANTO',
    }, {
        domanda: 'Contrazione del diaframma con suono tipico',
        risposta: 'INSULTO',
    }, {
        domanda: 'Lo fa il credente con una particolare collana',
        risposta: 'SINGHIOZZO',
    }, {
        domanda: 'Il nome dell\'attore Spacey',
        risposta: 'ROSARIO',
    }, {
        domanda: 'Famoso motore di ricerca',
        risposta: 'KEVIN',
    }, {
        domanda: 'Lo usi dopo avere cacato',
        risposta: 'GOOGLE',
    }, {
        domanda: 'Di forma sferica, lo lanciano gli atleti',
        risposta: 'BIDET',
    }, {
        domanda: 'Breve dormita pomeridiana',
        risposta: 'PESO',
    }, {
        domanda: 'Lo fa il carabiniere agli automobilisti ubriachi',
        risposta: 'PISOLINO',
    }],
    //Lista 57
    [{
        domanda: 'Accudisce una bambino quando mancano i genitori',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Salto in un burrone di un torrente',
        risposta: 'TATA',
    }, {
        domanda: 'Il tackle calcistico in italiano',
        risposta: 'CASCATA',
    }, {
        domanda: 'Storiella spiritosa raccontata per far ridere',
        risposta: 'SCIVOLATA',
    }, {
        domanda: 'Sostanza utilizzata in passato nei termometri',
        risposta: 'BARZELLETTA',
    }, {
        domanda: 'Con il riso nel sushi',
        risposta: 'MERCURIO',
    }, {
        domanda: 'Involucro cutaneo del pene in corrispondenza del glande',
        risposta: 'PESCE',
    }, {
        domanda: 'Prelibato alimento prodotto dallo storione',
        risposta: 'PREPUZIO',
    }, {
        domanda: 'Idea persistente e tormentosa',
        risposta: 'CAVIALE',
    }, {
        domanda: 'Atto teneramente affettuoso, carezza',
        risposta: 'OSSESSIONE',
    }, {
        domanda: 'Si può estrarre dal naso con le dita',
        risposta: 'COCCOLA',
    }, {
        domanda: 'Polvere piccante rossa ottenuta dal peperoncino',
        risposta: 'CACCOLA',
    }, {
        domanda: 'Si prende per stare tranquilli',
        risposta: 'PAPRICA',
    }, {
        domanda: 'Lo è Beppe Vessicchio',
        risposta: 'TRANQUILLANTE',
    }, {
        domanda: 'Scambiato per pesce, è mammifero',
        risposta: 'DIRETTORE',
    }],
    //Lista 58
    [{
        domanda: 'Il gusto del tè, oltre il limone',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Colora ciglia e sopracciglia',
        risposta: 'PESCA',
    }, {
        domanda: 'Libro che tratta le conoscenze umane nel complesso',
        risposta: 'MASCARA',
    }, {
        domanda: 'La disciplina che cura i disturbi del linguaggio',
        risposta: 'ENCICLOPEDIA',
    }, {
        domanda: 'È vecchia e vi ha le bestie zio Tobia',
        risposta: 'LOGOPEDIA',
    }, {
        domanda: 'Squamata e simbolo del Giappone',
        risposta: 'FATTORIA',
    }, {
        domanda: 'Ha le pupille squadrate e scala le pareti montuose',
        risposta: 'CARPA',
    }, {
        domanda: 'Si salva insieme ai cavoli',
        risposta: 'CAPRA',
    }, {
        domanda: 'Sinonimo di salma',
        risposta: 'CAPRA',
    }, {
        domanda: 'È misto quello piemontese',
        risposta: 'CADAVERE',
    }, {
        domanda: 'Da parati',
        risposta: 'BOLLITO',
    }, {
        domanda: 'Medicamento adesivo da porre su una ferita',
        risposta: 'CARTA',
    }, {
        domanda: 'Lo è l\'osso coperto dal gesso',
        risposta: 'CEROTTO',
    }, {
        domanda: 'Definizione corretta di checca',
        risposta: 'ROTTO',
    }, {
        domanda: 'Si prende in Inghilterra nel pomeriggio',
        risposta: 'OMOSESSUALE',
    }],
    //Lista 59
    [{
        domanda: 'La laurea di Renzo Piano',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'La paura degli spazi aperti',
        risposta: 'ARCHITETTURA',
    }, {
        domanda: 'L\'amore per i cani',
        risposta: 'AGORAFOBIA',
    }, {
        domanda: 'L\'amore per il cinema',
        risposta: 'CINOFILIA',
    }, {
        domanda: 'La nazione con Hong Kong',
        risposta: 'CINEFILIA',
    }, {
        domanda: 'La nazione con Tokyo',
        risposta: 'CINA',
    }, {
        domanda: 'Era detto il flagello di Dio',
        risposta: 'GIAPPONE',
    }, {
        domanda: 'Il nome di battesimo di Berlusconi',
        risposta: 'ATTILA',
    }, {
        domanda: 'È mestruale',
        risposta: 'SILVIO',
    }, {
        domanda: 'Il mezzo di trasporto di Trenitalia',
        risposta: 'CICLO',
    }, {
        domanda: 'Il suo suono è “etciù!”',
        risposta: 'TRENO',
    }, {
        domanda: 'Lo si fa per dichiarare l\'omosessualità',
        risposta: 'STARNUTO',
    }, {
        domanda: 'Contraccettivo maschile',
        risposta: 'COMING OUT',
    }, {
        domanda: 'Insaporisce il pomodoro nell’arrabbiata',
        risposta: 'PRESERVATIVO',
    }, {
        domanda: 'Sembra sia stata la causa del Covid',
        risposta: 'PEPERONCINO',
    }],
    //Lista 60
    [{
        domanda: 'Quante facce ha un dodecaedro?',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'A quanti anni è morto Gesù?',
        risposta: '12',
    }, {
        domanda: 'Quante sono le regioni italiane?',
        risposta: '33',
    }, {
        domanda: 'Cosa sono mossi o localmente mossi?',
        risposta: '20',
    }, {
        domanda: 'Averna, Braulio, Montenegro',
        risposta: 'MARI',
    }, {
        domanda: 'Lo sono al gusto i cibi zuccherati',
        risposta: 'AMARI',
    }, {
        domanda: 'Carlo, presentatore televisivo abbronzato',
        risposta: 'DOLCI',
    }, {
        domanda: 'Fanno film porno per guadagnare',
        risposta: 'CONTI',
    }, {
        domanda: 'Al fianco degli sposi durante le nozze',
        risposta: 'PORNOATTORI',
    }, {
        domanda: 'Si cariano',
        risposta: 'TESTIMONI',
    }, {
        domanda: 'Si mangiano al cinema',
        risposta: 'DENTI',
    }, {
        domanda: 'Servono a fermare la corsa di un mezzo',
        risposta: 'POP CORN',
    }, {
        domanda: 'Dal mare, fritti, ad anello',
        risposta: 'FRENI',
    }, {
        domanda: 'Cognome della celebre conduttrice Antonella ',
        risposta: 'CALAMARI',
    }, {
        domanda: 'Celebrano la messa',
        risposta: 'CLERICI',
    }],
    //Lista 61
    [{
        domanda: 'Diventano rosse per il freddo o l\'imbarazzo',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'La regione con Ancona e Macerata',
        risposta: 'GUANCE',
    }, {
        domanda: 'Il grado di parentela delle Kessler',
        risposta: 'MARCHE',
    }, {
        domanda: 'Lo sono l\'Orsa Maggiore e Minore',
        risposta: 'SORELLE',
    }, {
        domanda: 'Spuntano sul viso di chi ha l\'acne',
        risposta: 'COSTELLAZIONI',
    }, {
        domanda: 'Si puliscono con un cotton fioc',
        risposta: 'BRUFOLI',
    }, {
        domanda: 'Si bruciano correndo',
        risposta: 'ORECCHIE',
    }, {
        domanda: 'Si producono dal latte',
        risposta: 'CALORIE',
    }, {
        domanda: 'Sono da giardino, col cappello rosso',
        risposta: 'FORMAGGI',
    }, {
        domanda: 'Li produce il sarto, su misura',
        risposta: 'NANI',
    }, {
        domanda: 'Lo dici a chi non rivedrai più',
        risposta: 'ABITI',
    }, {
        domanda: 'Gli dice addio il maschio che si sposa',
        risposta: 'ADDIO',
    }, {
        domanda: 'In francese, per indicare i crudi di pesce',
        risposta: 'CELIBATO',
    }, {
        domanda: 'La cogli al balzo',
        risposta: 'CRUDITÉ',
    }, {
        domanda: 'Fa male quando si beve troppo',
        risposta: 'PALLA',
    }],
    //Lista 62
    [{
        domanda: 'Al vapore sono tipici dei ristoranti cinesi',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'A Natale ce li si da sotto il vischio come augurio',
        risposta: 'RAVIOLI',
    }, {
        domanda: 'I quadrati della scacchiera sono bianchi o ..?',
        risposta: 'BACI',
    }, {
        domanda: 'Dispregiativo per descrivere i cinesi: i musi..?',
        risposta: 'NERI',
    }, {
        domanda: 'Di che colore hanno tipicamente gli occhi i tedeschi?',
        risposta: 'GIALLI',
    }, {
        domanda: 'Slip che sostiene scroto e testicoli nello sport',
        risposta: 'AZZURRI',
    }, {
        domanda: 'Il papa ce l’ha di ermellino',
        risposta: 'SOSPENSORIO',
    }, {
        domanda: 'Secondo i Los Lobos devi parar a bailarla',
        risposta: 'STOLA',
    }, {
        domanda: 'È italiana quella con croissant e cappuccino',
        risposta: 'LA BAMBA',
    }, {
        domanda: 'Pasto prima del pranzo',
        risposta: 'COLAZIONE',
    }, {
        domanda: 'Lo sono colazione, pranzo e cena',
        risposta: 'COLAZIONE',
    }, {
        domanda: 'Sono presenti all’ultima cena',
        risposta: 'PASTI',
    }, {
        domanda: 'Si mangiano con il vin santo',
        risposta: 'APOSTOLI',
    }, {
        domanda: 'Li fa Santana con la chitarra',
        risposta: 'CANTUCCI',
    }, {
        domanda: 'Vennero forse estinti da un asteroide',
        risposta: 'ASSOLI',
    }],
    //Lista 63
    [{
        domanda: 'La pallavolo in inglese',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Pratica di suicidio giapponese',
        risposta: 'VOLLEY',
    }, {
        domanda: 'Si dice a chi compie gli anni',
        risposta: 'HARAKIRI',
    }, {
        domanda: 'Esclamazione di stupore con la W',
        risposta: 'AUGURI',
    }, {
        domanda: 'Abbreviazione delle Schutzstaffel naziste',
        risposta: 'WOW',
    }, {
        domanda: 'Lo sono il Libeccio e la Bora',
        risposta: 'SS',
    }, {
        domanda: 'Escono dal culo e puzzano',
        risposta: 'VENTI',
    }, {
        domanda: 'Le pronuncia il credente',
        risposta: 'SCORREGGE',
    }, {
        domanda: 'Vengono lanciate nello spazio per esplorarlo',
        risposta: 'PREGHIERE',
    }, {
        domanda: 'Mezzi a due ruote a pedalata',
        risposta: 'SONDE',
    }, {
        domanda: 'Si usano per pescare',
        risposta: 'BICICLETTE',
    }, {
        domanda: 'Le lanciavano gli indiani per attaccare o difendersi',
        risposta: 'CANNE',
    }, {
        domanda: 'Causano prurito se pungono',
        risposta: 'FRECCE',
    }, {
        domanda: 'Per suonare i violini',
        risposta: 'ZANZARE',
    }, {
        domanda: 'Sono a pecorelle se arriva la pioggia',
        risposta: 'ARCHETTI',
    }],
    //Lista 64
    [{
        domanda: 'Di mestiere effettua la forgiatura',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Nome di De Andrè',
        risposta: 'FABBRO',
    }, {
        domanda: 'È il migliore in uno sport',
        risposta: 'FABRIZIO',
    }, {
        domanda: 'Per un problema alla vista, confonde i colori',
        risposta: 'CAMPIONE',
    }, {
        domanda: 'Porta la prima luce del giorno',
        risposta: 'DALTONICO',
    }, {
        domanda: 'Il nome del comico Guzzanti',
        risposta: 'ALBA',
    }, {
        domanda: 'Il re che trasformava ciò che toccava in oro',
        risposta: 'CORRADO',
    }, {
        domanda: 'Tra il Do e il Mi',
        risposta: 'MIDA',
    }, {
        domanda: 'Vende penne e quaderni',
        risposta: 'RE',
    }, {
        domanda: 'L\'idolo dei pellerossa',
        risposta: 'CARTOLAIO',
    }, {
        domanda: 'Il contrario di stonato',
        risposta: 'TOTEM',
    }, {
        domanda: 'Lo è il vitello nel tipico piatto',
        risposta: 'INTONATO',
    }, {
        domanda: 'É famoso quello di Arianna',
        risposta: 'TONNATO',
    }, {
        domanda: 'Trappola per pesci, con la maglia',
        risposta: 'FILO',
    }, {
        domanda: 'Lo si dice quando si segna nel rugby',
        risposta: 'RETE',
    }],
    //Lista 65
    [{
        domanda: 'Secondo alcuni producono scie pericolose',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Abitano l\'Olimpo',
        risposta: 'AEREI',
    }, {
        domanda: 'Si superano o meno all’università',
        risposta: 'DEI',
    }, {
        domanda: 'Si fanno la notte',
        risposta: 'ESAMI',
    }, {
        domanda: 'I quadrati ne hanno quattro',
        risposta: 'SOGNI',
    }, {
        domanda: 'Sono legati da un rapporto di amicizia',
        risposta: 'LATI',
    }, {
        domanda: 'Li spari a Capodanno',
        risposta: 'AMICI',
    }, {
        domanda: 'Caricano a testa bassa',
        risposta: 'FUOCHI',
    }, {
        domanda: 'Lavorano in fabbrica',
        risposta: 'TORI',
    }, {
        domanda: 'Membri del Senato della Repubblica',
        risposta: 'OPERAI',
    }, {
        domanda: 'Persone estremamente grasse',
        risposta: 'SENATORI',
    }, {
        domanda: 'Li solleva il body builder',
        risposta: 'OBESI',
    }, {
        domanda: 'Uomini senza credo',
        risposta: 'PESI',
    }, {
        domanda: 'Si fanno annusare a chi sviene',
        risposta: 'ATEI',
    }, {
        domanda: 'Il sì russo',
        risposta: 'SALI',
    }],
    //Lista 66
    [{
        domanda: 'Con il filo per cucire',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il bar del Far West',
        risposta: 'AGO',
    }, {
        domanda: 'Ci si fa la cacca dentro',
        risposta: 'SALOON',
    }, {
        domanda: 'Grosso recipiente in legno per vino',
        risposta: 'WATER',
    }, {
        domanda: 'Le prende chi si decide',
        risposta: 'BOTTE',
    }, {
        domanda: 'Sotto agli occhi per la stanchezza',
        risposta: 'DECISIONI',
    }, {
        domanda: 'Per vedere lontano in montagna',
        risposta: 'OCCHIAIE',
    }, {
        domanda: 'Lo usano le api per pungere',
        risposta: 'BINOCOLO',
    }, {
        domanda: 'Con una coppia forma il full',
        risposta: 'PUNGIGLIONE',
    }, {
        domanda: 'Lo indossa il medico',
        risposta: 'TRIS',
    }, {
        domanda: 'Piccolo dispositivo per lo spionaggio',
        risposta: 'CAMICE',
    }, {
        domanda: 'Con uovo e pecorino nella carbonara',
        risposta: 'CIMICE',
    }, {
        domanda: 'Ci si appoggia la testa per dormire',
        risposta: 'GUANCIALE',
    }, {
        domanda: 'Lo formano dieci millimetri',
        risposta: 'CUSCINO',
    }, {
        domanda: 'La più piccola unità di ogni elemento',
        risposta: 'CENTIMETRO',
    }],
    //Lista 67
    [{
        domanda: 'Abitano di fronte',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Ladri con la bandana sulla scialuppa',
        risposta: 'DIRIMPETTAI',
    }, {
        domanda: 'Il più noto è Merlino',
        risposta: 'PIRATI',
    }, {
        domanda: 'Il lavoro di Maurizio Gasparri',
        risposta: 'MAGO',
    }, {
        domanda: 'Bastoncino di pane',
        risposta: 'POLITICO',
    }, {
        domanda: 'A motore, per segare il legno',
        risposta: 'GRISSINO',
    }, {
        domanda: 'La faceva il Canova, anche con il gesso',
        risposta: 'SEGA',
    }, {
        domanda: 'Si poggia sul vinile per l\'ascolto',
        risposta: 'SCULTURA',
    }, {
        domanda: 'Se indossata è corta, allora è detta “mini”',
        risposta: 'PUNTINA',
    }, {
        domanda: 'La indossa il giudice',
        risposta: 'GONNA',
    }, {
        domanda: 'La sorella di papà',
        risposta: 'TOGA',
    }, {
        domanda: 'Che denota o rivela scarsissima intelligenza',
        risposta: 'ZIA',
    }, {
        domanda: 'Lo è Kim Jong-un',
        risposta: 'STUPIDO',
    }, {
        domanda: 'Scorre a Torino',
        risposta: 'DITTATORE',
    }, {
        domanda: 'Contrario di tanto',
        risposta: 'PO',
    }],
    //Lista 68
    [{
        domanda: 'Lo sono quelle della X e Y',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Prima del cavallo, nella Briscola',
        risposta: 'ASSI',
    }, {
        domanda: 'Usate per legare un prigioniero',
        risposta: 'FANTE',
    }, {
        domanda: 'Indossate al collo',
        risposta: 'CATENE',
    }, {
        domanda: 'Pianta che pizzica al contatto',
        risposta: 'COLLANE',
    }, {
        domanda: 'Il gigante della flora',
        risposta: 'ORTICA',
    }, {
        domanda: 'Il gruppo de “La Terra dei Cachi”',
        risposta: 'BAOBAB',
    }, {
        domanda: 'Autori di truffe',
        risposta: 'ELIO E LE STORIE TESE',
    }, {
        domanda: 'Si pelano, arancioni',
        risposta: 'TRUFFATORI',
    }, {
        domanda: 'I frutti con il gheriglio',
        risposta: 'CAROTE',
    }, {
        domanda: 'Lo sono cocaina ed eroina',
        risposta: 'NOCI',
    }, {
        domanda: 'Contanti assieme alle banconote',
        risposta: 'DROGHE',
    }, {
        domanda: 'Misurano consuetamente i salumi',
        risposta: 'MONETE',
    }, {
        domanda: 'Pagati più delle normali ore di lavoro',
        risposta: 'ETTI',
    }, {
        domanda: 'Lo erano Stalin, Hitler, Castro',
        risposta: 'STRAORDINARI',
    }],
    //Lista 69
    [{
        domanda: 'Recinzione vegetale',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Pietanza costituita di verdure crude e condite',
        risposta: 'SIEPE',
    }, {
        domanda: 'Si fuma nelle canne',
        risposta: 'INSALATA',
    }, {
        domanda: 'Si mangia alla prima comunione',
        risposta: 'CANNABIS',
    }, {
        domanda: 'Si dice quando ci si fa male',
        risposta: 'OSTIA',
    }, {
        domanda: 'Capitale della Polonia',
        risposta: 'AHIA!',
    }, {
        domanda: 'Poco meno che unica',
        risposta: 'VARSAVIA',
    }, {
        domanda: 'Animale che fa “cra”',
        risposta: 'RARA',
    }, {
        domanda: 'Scappa di fronte al pericolo',
        risposta: 'RANA',
    }, {
        domanda: 'Lo è il cubo',
        risposta: 'CODARDO',
    }, {
        domanda: 'Animale che devasta il pollaio',
        risposta: 'SOLIDO',
    }, {
        domanda: 'Invecchia in cantina',
        risposta: 'VOLPE',
    }, {
        domanda: 'Pietra preziosa rossa',
        risposta: 'VINO',
    }, {
        domanda: 'La decisione della giuria',
        risposta: 'RUBINO',
    }, {
        domanda: 'Il colore della cacca',
        risposta: 'VERDETTO',
    }],
    //Lista 70
    [{
        domanda: 'Primo nome di Cavour',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'L\'oceano più grande del mondo',
        risposta: 'CAMILLO',
    }, {
        domanda: 'Lo è Mike Tyson',
        risposta: 'PACIFICO',
    }, {
        domanda: 'Quello di Berlino divideva la città',
        risposta: 'PUGILE',
    }, {
        domanda: 'Acrobazia al volo, spalle alla porta, nel calcio',
        risposta: 'MURO',
    }, {
        domanda: 'Lo fa l’acqua appena prima di buttare la pasta',
        risposta: 'ROVESCIATA',
    }, {
        domanda: 'Il nome del celebre ballerino Bolle',
        risposta: 'BOLLE',
    }, {
        domanda: 'Il nome del celebre attore Clooney',
        risposta: 'ROBERTO',
    }, {
        domanda: 'La razza del cane Rex',
        risposta: 'GEORGE',
    }, {
        domanda: 'In alcune tribù, dice di comunicare con gli spiriti',
        risposta: 'PASTORE TEDESCO',
    }, {
        domanda: 'Lo sport sulla neve con la tavola',
        risposta: 'SCIAMANO',
    }, {
        domanda: 'Venduto in zollette',
        risposta: 'SNOWBOARD',
    }, {
        domanda: 'In cucina è un metallo utilizzato in fogli',
        risposta: 'ZUCCHERO',
    }, {
        domanda: 'Lo è Agassi',
        risposta: 'ALLUMINIO',
    }, {
        domanda: 'Era di Nazaret',
        risposta: 'TENNISTA',
    }],
    //Lista 71
    [{
        domanda: 'Al collo dei manager',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Al dito della sposa',
        risposta: 'CRAVATTA',
    }, {
        domanda: 'Il nome di Jagger degli Stones',
        risposta: 'FEDE',
    }, {
        domanda: 'La si usa per pettinare dei lunghi capelli',
        risposta: 'MICK',
    }, {
        domanda: 'Tesla la produce elettrica',
        risposta: 'SPAZZOLA',
    }, {
        domanda: 'La compagna di Linus',
        risposta: 'AUTOMOBILE',
    }, {
        domanda: 'É famosa la Beretta',
        risposta: 'COPERTA',
    }, {
        domanda: 'Lo è Massimo Giletti',
        risposta: 'PISTOLA',
    }, {
        domanda: 'Sotterra i morti',
        risposta: 'PRESENTATORE',
    }, {
        domanda: 'A scuola, chi cerca di ingraziarsi i professori',
        risposta: 'BECCHINO',
    }, {
        domanda: 'A terra, fuori dalla porta di casa',
        risposta: 'LECCHINO',
    }, {
        domanda: 'Si dice di chi è molto attaccato alla genitrice',
        risposta: 'ZERBINO',
    }, {
        domanda: 'Lo è Jorge Mario Bergoglio',
        risposta: 'MAMMONE',
    }, {
        domanda: 'Il maschio dominante in un branco',
        risposta: 'PAPA',
    }, {
        domanda: 'Fa coppia con Romeo a Verona',
        risposta: 'ALFA',
    }],
    //Lista 72
    [{
        domanda: 'Il frutto con il prosciutto crudo',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Pepita estratta dal naso',
        risposta: 'MELONE',
    }, {
        domanda: 'Con le spine, non necessita acqua',
        risposta: 'CACCOLA',
    }, {
        domanda: 'Il simbolo sulla bandiera nazista',
        risposta: 'CACTUS',
    }, {
        domanda: 'Disegno tecnico dall\'alto di uno spazio',
        risposta: 'SVASTICA',
    }, {
        domanda: 'Dai denti a sciabola',
        risposta: 'PIANTA',
    }, {
        domanda: 'Lo è quella di visone',
        risposta: 'TIGRE',
    }, {
        domanda: 'Copre il tavolo durante i pasti',
        risposta: 'PELLICCIA',
    }, {
        domanda: 'Si forma sulla frutta in decomposizione',
        risposta: 'TOVAGLIA',
    }, {
        domanda: 'Alle estremità delle dita',
        risposta: 'MUFFA',
    }, {
        domanda: 'Le montano i campeggiatori',
        risposta: 'UNGHIE',
    }, {
        domanda: 'Cadono sempre in piedi',
        risposta: 'TENDE',
    }, {
        domanda: 'Ingrediente principale della parmigiana',
        risposta: 'GATTI',
    }, {
        domanda: 'In dotazione alla polizia, per picchiare',
        risposta: 'MELANZANE',
    }, {
        domanda: 'Copre una ferita per la guarigione',
        risposta: 'MANGANELLO',
    }],
    //Lista 73
    [{
        domanda: 'Piccoli pesci sott’olio o sotto sale',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Sono mille quelle della celebre corsa',
        risposta: 'ACCIUGHE',
    }, {
        domanda: 'Sono di soia quelli vegani',
        risposta: 'MIGLIA',
    }, {
        domanda: 'Erano a spazzolino quelli di Hitler',
        risposta: 'HAMBURGER',
    }, {
        domanda: 'Alcuni li portano a manubrio',
        risposta: 'BAFFI',
    }, {
        domanda: 'Piccoli punti bruni sulla pelle',
        risposta: 'BAFFI',
    }, {
        domanda: 'Possono essere prataioli',
        risposta: 'NEI',
    }, {
        domanda: 'Compaiono sul viso durante l’adolescenza',
        risposta: 'FUNGHI',
    }, {
        domanda: 'Prodotto tipico di Ariccia',
        risposta: 'BRUFOLI',
    }, {
        domanda: 'Lo è una donna in stato di gravidanza',
        risposta: 'PORCHETTA',
    }, {
        domanda: 'Lo erano Nerone, Tito e Traiano',
        risposta: 'INCINTA',
    }, {
        domanda: 'Lo può concedere una banca',
        risposta: 'IMPERATORE',
    }, {
        domanda: 'Lo chiede chi vuole pagare al ristorante',
        risposta: 'PRESTITO',
    }, {
        domanda: 'Effusioni preliminari',
        risposta: 'CONTO',
    }, {
        domanda: 'Si mangia quello del pollo',
        risposta: 'PETTING',
    }],
    //Lista 74
    [{
        domanda: 'Costruisce dighe',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Al collo se fa freddo',
        risposta: 'CASTORO',
    }, {
        domanda: 'Neutrale al confine con il Piemonte',
        risposta: 'SCIARPA',
    }, {
        domanda: 'La porzione di carne celebre a Firenze',
        risposta: 'SVIZZERA',
    }, {
        domanda: 'Si forma sul ferro esposto all’umidità',
        risposta: 'FIORENTINA',
    }, {
        domanda: 'La vecchietta con i doni',
        risposta: 'RUGGINE',
    }, {
        domanda: 'Nome inglese per investigatore',
        risposta: 'BEFANA',
    }, {
        domanda: 'L\'animale del segno del Cancro',
        risposta: 'DETECTIVE',
    }, {
        domanda: 'È Sforzesco a Milano',
        risposta: 'GRANCHIO',
    }, {
        domanda: 'Il simbolo del WWF',
        risposta: 'CASTELLO',
    }, {
        domanda: 'Se mangiati in quantità, fanno scorreggiare',
        risposta: 'PANDA',
    }, {
        domanda: 'Li incontra Gulliver',
        risposta: 'FAGIOLI',
    }, {
        domanda: 'Cucinati tipicamente in Abruzzo',
        risposta: 'LILLIPUZIANI',
    }, {
        domanda: 'A cavalcioni, permettono a Harry Potter di volare',
        risposta: 'ARROSTICINI',
    }, {
        domanda: 'Con le strisce nella bandiera statunitense',
        risposta: 'SCOPE',
    }],
    //Lista 75
    [{
        domanda: 'Il più vasto deserto del mondo',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Vi si ripongono i surgelati',
        risposta: 'SAHARA',
    }, {
        domanda: 'Ci vanno i bambini dai 3 ai 5 anni circa',
        risposta: 'CONGELATORE',
    }, {
        domanda: 'La sua capitale è Tirana',
        risposta: 'ASILO',
    }, {
        domanda: 'La sua barriera viene rotta dagli aerei',
        risposta: 'ALBANIA',
    }, {
        domanda: 'Viene dopo il lampo',
        risposta: 'SUONO',
    }, {
        domanda: 'Abitazione tipica del Salento',
        risposta: 'TUONO',
    }, {
        domanda: 'Batte nei vivi',
        risposta: 'TRULLO',
    }, {
        domanda: 'Si scava e decora per Halloween',
        risposta: 'CUORE',
    }, {
        domanda: 'Ha il letto ma non è materasso',
        risposta: 'ZUCCA',
    }, {
        domanda: 'Scorre nel corpo umano',
        risposta: 'FIUME',
    }, {
        domanda: 'Il principe di Cenerentola',
        risposta: 'SANGUE',
    }, {
        domanda: 'Lo diventa Harry Potter con il mantello',
        risposta: 'AZZURRO',
    }, {
        domanda: 'Il paese del canguro',
        risposta: 'INVISIBILE',
    }, {
        domanda: 'Parco divertimenti dedicato a Disney',
        risposta: 'AUSTRALIA',
    }],
    //Lista 76
    [{
        domanda: 'Lo scienziato che studia le rocce',
        risposta: 'GAMBERONI',
    }, {
        domanda: 'Il cantante che con le tonalità più alte',
        risposta: 'GEOLOGO',
    }, {
        domanda: 'Il mammifero più grande del mondo',
        risposta: 'SOPRANO',
    }, {
        domanda: 'La sostanza più dura in natura',
        risposta: 'BALENA',
    }, {
        domanda: 'Si ottiene dalla bollitura dell’acqua',
        risposta: 'DIAMANTE',
    }, {
        domanda: 'Per scrivere su una lavagna',
        risposta: 'VAPORE',
    }, {
        domanda: 'Viene dopo il bruco',
        risposta: 'GESSO',
    }, {
        domanda: 'Lo è la Vedova Nera in natura',
        risposta: 'FARFALLA',
    }, {
        domanda: 'Gli animali con scheletro',
        risposta: 'RAGNO',
    }, {
        domanda: 'Il galateo dice di non appoggiarli sul tavolo',
        risposta: 'VERTEBRATI',
    }, {
        domanda: 'Ne sono ricchi i fagioli e la carne',
        risposta: 'GOMITI',
    }, {
        domanda: 'La famiglia delle cozze',
        risposta: 'PROTEINE',
    }, {
        domanda: 'Riposano in pace',
        risposta: 'MOLLUSCHI',
    }, {
        domanda: 'Sono Di Maria nel celebre programma',
        risposta: 'MORTI',
    }, {
        domanda: 'Ti aiutano a camminare sulla neve fresca',
        risposta: 'AMICI',
    }]
]

export {
    bgColor,
    drawerRoutes,
    allPaths,
    List
}


